import React, { useState, useRef, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Dropdown,
  DropdownButton,
} from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Button, Spinner } from "reactstrap";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import plus_icon from "../../assets/images/icon/plus.svg";
import check_icon from "../../assets/images/icon/checked-icon.svg";
import Select from "react-select";
import white_cross from "../../assets/images/icon/white-cross.svg";
import info_icon from "../../assets/images/icon/info_icon.svg";
import available_round from "../../assets/images/icon/available-round.png";
import four_dost from "../../assets/images/icon/four-dots.svg";
import delete_icon from "../../assets/images/icon/delete.svg";

import action3 from "../../assets/images/brands/Rejected.svg";
import screening_icon from "../../assets/images/brands/Selected.svg";
import progress_icon from "../../assets/images/brands/In-progess.svg";
import pending_icon from "../../assets/images/brands/Pending.svg";

import naukricom from "../../assets/images/icon/nakricom.svg";
import indeed from "../../assets/images/icon/indeed.svg";
import monster from "../../assets/images/icon/monster.svg";
import linkedins from "../../assets/images/icon/linkedin.svg";
import cross from "../../assets/images/icon/cross.svg";
import { checkPermissionStatus } from "helpers/utils";
import { getAllSkills, getRoundsData } from "services/commonService";
import { CreateNewOrganization } from "services/OrganizationServices";
import { CreateNewOrgSPOC } from "services/OrganizationSPOCServices";
import { toast } from "react-toastify";
import { faExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  fetchinterViewers,
  generateDescriptionHelper,
  generateSkills,
  getJobTitle,
} from "helpers/backend_helper";
import { isEmpty } from "lodash";
import {
  decryptDataFromArray,
  encryptDataToArray,
  decryptDataFromArrayV2,
} from "helpers/EncDec";
import { Tooltip } from "react-tooltip";
import { ReactSortable } from "react-sortablejs";
import { MultiSelect } from "react-multi-select-component";
import { useTranslation } from "react-i18next";
import JobPublishForm from "../../components/JobPlatform";
import { getUserInfo, getUserToken } from "helpers/authHelper";
import { FetchAllRoundTemplateOptions } from "services/RoundTemplateServices";
import DatePicker from "react-datepicker";
import { parse } from "qs";
import { GetCompanyData } from "services/CompanyService";
import { Checkbox } from "rsuite";
import JobDescription from "./JobDescription";
import authHeader from "helpers/jwt-token-access/auth-token-header";
import api from "../../api";

const CreateJobNew = () => {
  const { t } = useTranslation();
  // State to track the current step, form data, and submission status
  const [formFields, setformField] = useState(() => {
    try {
      const parsed = JSON.parse(
        localStorage.getItem("client_company")
      );

      const decrypted_job_config =
        decryptDataFromArrayV2(parsed);

      console.log(
        decrypted_job_config,
        "decrypted_job_config"
      );

      return (
        decrypted_job_config?.data?.jobFormConfig
          ?.fields?.basic || {}
      );

    } catch (err) {
      console.error(
        "Failed to parse clientCredentials:",
        err
      );

      return {};
    }
  });
  const [currentStep, setCurrentStep] = useState(1);
  const [company, setCompany] = useState({});
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [statePayload, setStatePayload] = useState({
    min_salary: 0,
    max_salary: 10000,
    min_exp: 0,
    max_exp: 10,
    number_of_openings: 1,
    status: "1",
    location_mapped_with: formFields?.jobMappingWith || "city",
    shift_start: "",
    shift_end: "",
    mode_of_job: "Onsite",
    video_analysis_ques: "NA",
    specialization: "",
    relevant_experience: "",
    female_candidates_preferred: false,
    video_analysis_score: 0,
    relevance_score: 0,
  });
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [vtypes, setVType] = useState([]);
  const [jobTitle, setJobTitle] = useState([]);
  const [jobTitledata, setJobTitleData] = useState([]);
  const [City, setCity] = useState([]);
  const [allCityLocations, setAllCityLocations] = useState([]);
  const [FranchiseList, setFranchiseList] = useState([]);
  const [allFranchiseLocations, setAllFranchiseLocations] = useState([]);
  const [allDepartments, setAllDepartments] = useState([]);
  const [roundList, setRoundList] = useState([]);
  const [allRoundList, setAllRoundList] = useState([]);
  const [selectedRounds, setSelectedRounds] = useState([]);
  const [contentLoading, setContentLoading] = useState(false);
  const [allSkills, setAllSkills] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [interviewerList, setInterviewerList] = useState([]);
  const [skills, setSkills] = useState([]);
  const [allSavedSkills, setAllSavedSkills] = useState([]);
  const [jobStatus, setJobStatus] = useState("");
  const [isRemoteJOb, IsRemoteJOb] = useState(false);

  const [partTimeType, setPartTimeType] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const subdomain = localStorage.getItem("subdomain");
  const isBehaviourScoreEnabled =
    localStorage.getItem("isBehaviourScoreEnabled") === "true";
  const [uploadedFiles, setUploadedFiles] = useState({
    contract_compliance_documents: [],
  });
  const [isSocialEnable, setIsSocialEnable] = useState(
    () => localStorage.getItem("isSocialEnabled") === "true"
  );

  // console.log(formFields, "formFields");

  const modules = {};

  const formats = [];

  const expectedTimeOptions = [
    { label: "Part-Time", value: "Part-Time" },
    { label: "Full-Time", value: "Full-Time" },
    // { label: "Contract", value: "Contract" },
    // { label: "Freelance", value: "Freelance" },
    // { label: "Temporary", value: "Temporary" },
  ];
  const interviewTypes = [
    { label: "Offline", value: "0" },
    { label: "Online", value: "1" },
  ];
  const [checkedPlatforms, setCheckedPlatforms] = useState({
    all: false,
    naukri: false,
    linkedin: false,
    indeed: false,
    monster: false,
  });
  // Handle form input changes
  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleStatusChange = e => {
    let status =
      e.value == 0
        ? "pending"
        : e.value == 1
          ? "approve"
          : e.value == 2
            ? "post"
            : e.value == 3
              ? "reject"
              : "";
    if (checkPermissionStatus("job-list", status)) {
      // toast.success("You have Enough Permisison!");
      setJobStatus(e.value);
    } else {
      toast.error("You don't have Enough Permisison!");
    }
  };

  const handleVtypeSelection = vacancyID => {
    setStatePayload(prevState => ({
      ...prevState,
      vacancy_type_id: vacancyID,
    }));
  };

  const handleJobSelection = jobId => {
    const selectedJob = jobTitledata.find(job => job.id === parseInt(jobId));
    // console.log(selectedJob,"selectedJob")
    if (selectedJob) {
      setStatePayload(prev => ({
        ...prev,
        job_id: selectedJob.id,
        description: selectedJob.job_description || "",
        // department_id: selectedJob?.departmentDetails?.id
        //   ? [selectedJob.departmentDetails.id]
        //   : [],
        title: selectedJob.job_title,
      }));

      // ✅ Safely match department if present
      // const deptId = selectedJob?.departmentDetails?.id;

      // const deptMatch = deptId
      //   ? extendedDeptOptions.find(dept => dept.value === deptId)
      //   : null;

      // setSelectedDepts(deptMatch ? [deptMatch] : []); // 👈 fallback to empty array
      // ✅ Auto-set skills
      const autoSkills =
        selectedJob.skillsData?.map(skill => ({
          id: skill.id,
          label: skill.name,
          removable: false,
        })) || [];

      setSkills(autoSkills);
    }
  };
  // Define validation functions for each step
  const validateStep1 = () => {
    let errorObj = {};
    if (isEmpty(statePayload?.title)) {
      errorObj = {
        ...errorObj,
        title: "Title is Required!",
      };
    }
    // console.log(statePayload?.job_id,"statePayload?.job_id")
    if (
      formFields?.jobTitle?.required &&
      !statePayload?.job_id
    ) {
      errorObj = {
        ...errorObj,
        job_id: "Job Title is Required!",
      };
    }
    if (isEmpty(statePayload?.vacancy_type_id)) {
      errorObj = {
        ...errorObj,
        vacancy_type_id: "Position Level is Required!",
      };
    }

    if (
      isNaN(Number(statePayload?.number_of_openings)) ||
      Number(statePayload?.number_of_openings) <= 0 ||
      Number(statePayload?.number_of_openings) > 25
    ) {
      errorObj = {
        ...errorObj,
        number_of_openings: "Number of openings should be between 1 and 25!",
      };
    }

    // if (isEmpty(statePayload?.mode_of_job)) {
    //   errorObj = {
    //     ...errorObj,
    //     mode_of_job: "Mode of Job is Required!",
    //   };
    // }
    if (isEmpty(statePayload?.number_of_jobs)) {
      errorObj = {
        ...errorObj,
        number_of_jobs: "Number of Vacancies is Required!",
      };
    }

    if (isEmpty(statePayload?.department_id)) {
      errorObj = {
        ...errorObj,
        department_id: "Department is Required!",
      };
    }

    if (!isRemoteJOb) {
      if (
        ["franchise"].includes(
          statePayload?.location_mapped_with?.toLowerCase()
        ) &&
        isEmpty(statePayload?.franchise_id?.toString())
      ) {
        errorObj = {
          ...errorObj,
          franchise_id: "Dealership is Required!",
        };
      }
      if (!isRemoteJOb) {
        if (
          !["franchise"].includes(
            statePayload?.location_mapped_with?.toLowerCase()
          ) &&
          selectedCities.length == 0
        ) {
          errorObj = {
            ...errorObj,
            city_id: "City is Required!",
          };
        }


      }
      if (
        formFields?.jobLocation?.visible &&
        ["franchise"].includes(
          statePayload?.location_mapped_with?.toLowerCase()
        ) &&
        selectedFranchiseLocations.length === 0
      ) {
        errorObj = {
          ...errorObj,
          selectedFranchiseLocations: "Job Location is Required!",
        };
      }
      if (
        formFields?.jobLocation?.visible &&
        !["franchise"].includes(
          statePayload?.location_mapped_with?.toLowerCase()
        ) &&
        selectedCityLocations.length === 0
      ) {
        errorObj = {
          ...errorObj,
          selectedCityLocations: "Job Location is Required!",
        };
      }
    }

    if (isEmpty(statePayload?.qualification)) {
      errorObj = {
        ...errorObj,
        qualification: "Qualification is Required!",
      };
    }
    if (isEmpty(statePayload?.experience)) {
      errorObj = {
        ...errorObj,
        experience: "Experience is Required!",
      };
    }
    if (skills.length === 0) {
      errorObj = {
        ...errorObj,
        skills: "Skills are Required!",
      };
    }

    const arr = statePayload?.qualification?.split(",")?.map(s => s?.trim());
    if (arr && Array.isArray(arr)) {
      arr.forEach(s => {
        const specializationMap = statePayload?.specializationMap || {};

        if (isEmpty(specializationMap[s])) {
          errorObj = {
            ...errorObj,
            specializationMap: {
              ...errorObj?.specializationMap,
              [s]: "Specialization is Required!",
            },
          };
        }
      });
    }

    if (
      isEmpty(statePayload?.min_exp) &&
      isEmpty(statePayload?.relevant_experience)
    ) {
      errorObj = {
        ...errorObj,
        min_exp: "Either Minimum or Relevant Experience is Required!",
      };
    }
    if (
      statePayload?.min_exp &&
      statePayload?.relevant_experience &&
      Number(statePayload?.min_exp) < Number(statePayload?.relevant_experience)
    ) {
      errorObj = {
        ...errorObj,
        relevant_experience: "Relevant Exp. should be less than Min Exp.!",
      };
    }
    // if (parseInt(statePayload?.min_exp) > parseInt(statePayload?.max_exp)) {
    //   errorObj = {
    //     ...errorObj,
    //     min_exp: "Min Experience is less then Max Experience!",
    //   };
    // }
    // console.log(errorObj, "errorObj");
    if (Object.keys(errorObj)?.length > 0) {
      setErrors(errorObj);
      return false;
    }

    return true;
  };

  const validateStep2 = () => {
    let errorObj = {};
    if (selectedRounds?.length === 0) {
      errorObj = {
        ...errorObj,
        roundList: "Round List is Required!",
      };
    }
    if (
      selectedRounds?.length > 0 &&
      selectedRounds?.filter(
        el => el?.type === "Interview" && !el?.interviewer_id
      )?.length > 0
    ) {
      errorObj = {
        ...errorObj,
        roundList: "Please Select Interviewers for Interview Rounds",
      };
    }
    if (
      selectedRounds?.length > 0 &&
      selectedRounds?.filter(
        el => el?.type === "Interview" && !el?.meeting_type
      )?.length > 0
    ) {
      errorObj = {
        ...errorObj,
        roundList: "Please Select Interview Type for Interview Rounds",
      };
    }
    if (Object.keys(errorObj)?.length > 0) {
      setErrors(errorObj);
      return false;
    }
    return true;
  };

  const validateStep3 = () => {
    let errorObj = {};
    if (
      parseInt(statePayload?.min_salary) > parseInt(statePayload?.max_salary) &&
      statePayload?.max_salary
    ) {
      errorObj = {
        ...errorObj,
        min_salary: "Min Salary is less then Max Salary!",
      };
    }

    if (
      isNaN(Number(statePayload?.min_salary)) ||
      Number(statePayload?.min_salary) <= 0
    ) {
      errorObj = {
        ...errorObj,
        min_salary: "min salary should be grater than 1",
      };
    }
    if (
      isNaN(Number(statePayload?.max_salary)) ||
      Number(statePayload?.max_salary) <= 0
    ) {
      errorObj = {
        ...errorObj,
        max_salary: "max salary should be grater than 1",
      };
    }

    if (isEmpty(statePayload?.expected_time)) {
      errorObj = {
        ...errorObj,
        expected_time: "Expected Time is Required!",
      };
    }
    if (
      statePayload?.expected_time === "Part-Time" &&
      statePayload.partTimeType === ""
    ) {
      errorObj = {
        ...errorObj,
        partTimeType: t(`job-list.error_msg.part_time`),
      };
    }
    if (
      statePayload?.expected_time === "Part-Time" &&
      statePayload.partTimeType === ""
    ) {
      errorObj = {
        ...errorObj,
        partTimeType: t(`job-list.error_msg.part_time`),
      };
    }
    if (
      isEmpty(statePayload?.relevance_score) &&
      company?.company_name != "Mahindra"
    ) {
      errorObj = {
        ...errorObj,
        relevance_score: "This Field is Required!",
      };
    }
    if (
      (isEmpty(statePayload?.video_analysis_score) ||
        parseInt(statePayload?.video_analysis_score) <= 0) &&
      isBehaviourScoreEnabled &&
      company?.company_name != "Mahindra"
    ) {
      errorObj = {
        ...errorObj,
        video_analysis_score: t(`job-list.error_msg.video_analysis_score`),
      };
    }
    if (isEmpty(statePayload?.video_analysis_ques)) {
      errorObj = {
        ...errorObj,
        video_analysis_ques: "This Field is Required!",
      };
    }
    if (
      (isEmpty(jobStatus) || !jobStatus) &&
      company?.company_name != "Mahindra"
    ) {
      errorObj = {
        ...errorObj,
        jobStatus: "This Field is Required!",
      };
    }

    if (Object.keys(errorObj)?.length > 0) {
      setErrors(errorObj);
      return false;
    }

    return true;
  };

  const validateStep4 = () => {
    let errors = {};

    if (!humanCloudProcessAMValues?.collaboration_tool) {
      errors = {
        ...(errors || {}),
        collaboration_tool: "Collaboration Tools is required",
      };
    } else {
      errors = {
        ...(errors || {}),
        collaboration_tool: null,
      };
    }

    if (!humanCloudProcessAMValues?.programming_languages) {
      errors = {
        ...(errors || {}),
        programming_languages: "Programming Languages is required",
      };
    } else {
      errors = {
        ...(errors || {}),
        programming_languages: null,
      };
    }

    if (!humanCloudProcessAMValues?.ide_preferences) {
      errors = {
        ...(errors || {}),
        ide_preferences: "IDE Preferences is required",
      };
    } else {
      errors = {
        ...(errors || {}),
        ide_preferences: null,
      };
    }

    if (!humanCloudProcessAMValues?.version_control_systems) {
      errors = {
        ...(errors || {}),
        version_control_systems: "Version Control Systems is required",
      };
    } else {
      errors = {
        ...(errors || {}),
        version_control_systems: null,
      };
    }

    if (!humanCloudProcessAMValues?.timesheet_process) {
      errors = {
        ...(errors || {}),
        timesheet_process: "Timesheet Process is required",
      };
    } else {
      errors = {
        ...(errors || {}),
        timesheet_process: null,
      };
    }

    if (!humanCloudProcessAMValues?.billing_process) {
      errors = {
        ...(errors || {}),
        billing_process: "Billing Process is required",
      };
    } else {
      errors = {
        ...(errors || {}),
        billing_process: null,
      };
    }

    setAMValueErrors(errors);

    if (!humanCloudProcessAMValues?.contract_compliance_documents?.length) {
      toast.error("Contracting & Compliance Documents is required");

      errors = {
        ...(errors || {}),
        contract_compliance_documents: true,
      };
    } else {
      errors = {
        ...(errors || {}),
        contract_compliance_documents: null,
      };
    }

    if (!humanCloudProcessAMValues?.nda_ip_protection_agreements?.length) {
      toast.error("NDA & IP Protection Agreements is required");

      errors = {
        ...(errors || {}),
        nda_ip_protection_agreements: true,
      };
    } else {
      errors = {
        ...(errors || {}),
        nda_ip_protection_agreements: null,
      };
    }

    return !Object.values(errors)?.some(val => !!val);
  };

  // Move to the next step
  const nextStep = () => {
    setErrors({});
    setCurrentStep(currentStep + 1);
  };

  // Move to the previous step
  const prevStep = () => {
    setErrors({});
    setCurrentStep(currentStep - 1);
  };
  const handleSaveAndContinue = e => {
    if (currentStep === 1) {
      if (validateStep1()) {
        nextStep();
      }
    }
    if (currentStep === 2) {
      if (validateStep2()) {
        nextStep();
      }
    } else if (currentStep === 3) {
      if (validateStep3()) {
        if (isHumanCloudProcessAppl()) {
          nextStep();
        } else {
          handleSubmit(e);
        }
      }
    } else if (currentStep === 4) {
      if (validateStep4()) {
        handleSubmit(e);
      }
    }
  };

  const [selectedOption, setSelectedOption] = useState(null);
  const [currentStatus, setCurrentStatus] = useState("");

  // Handle single select change
  const handleSingleSelectChange = option => {
    setSelectedOption(option);
  };

  const [selectedDegrees, setSelectedDegrees] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const qualifications = [
    "High School",
    "Diploma",
    // "Associate Degree",
    "Bachelor's Degree",
    "Master's Degree",
    "Doctorate",
    "Professional Certification",
  ];

  const handleDegreeSelect = degree => {
    if (selectedDegrees.length < 3 && !selectedDegrees.includes(degree)) {
      const updatedDegrees = [...selectedDegrees, degree];
      setSelectedDegrees(updatedDegrees);

      // Update the statePayload with selected degrees
      setStatePayload(prevState => ({
        ...prevState,
        qualification: updatedDegrees.join(", "), // Store as a comma-separated string
        specializationMap: { ...prevState?.specializationMap, [degree]: "" }, // Initialize specializationMap if it doesn't exist
      }));
    }
    setDropdownOpen(false);
  };

  const handleDegreeRemove = degree => {
    const updatedDegrees = selectedDegrees.filter(d => d !== degree);
    setSelectedDegrees(updatedDegrees);
    setStatePayload(prevState => {
      const { specializationMap = {} } = prevState;

      // remove the degree immutably
      const { [degree]: _, ...updatedSpecializationMap } = specializationMap;

      return {
        ...prevState,
        specializationMap: updatedSpecializationMap,
        qualification: updatedDegrees.join(", "),
      };
    });
  };

  //map specialization with selected degree
  const handleSpecializationInput = (selectedDegree, text) => {
    let specializationMap = statePayload?.specializationMap || {};
    specializationMap[selectedDegree] = text;
    setStatePayload(prevState => ({
      ...prevState,
      specializationMap: specializationMap,
    }));
  };

  const handleClickOutside = event => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownOpen(false);
    }
  };

  const fetchVacancyTypeData = () => {
    const language = localStorage.getItem("lang_id") || "1";

    api
      .get(
        `${process.env.REACT_APP_API_URL}/admin/vacancyType/fetch-vacancytype`,
      )
      .then(response => {
        let responseData = response?.data;
        if (responseData) {
          responseData = decryptDataFromArray(responseData);
        }

        const { success, allVacType } = responseData || {};

        if (success && Array.isArray(allVacType)) {
          const data = allVacType.map(item => ({
            id: item?.id,
            label: item?.title,
            value: item?.vacancy_name,
          }));
          setVType(data);
        }
      })
      .catch(err => {
        console.error("Error fetching Position Level data:", err);
      });
  };

  const fetchJobTitleeData = async () => {
    try {
      let response = await getJobTitle();

      let responseData = response;
      if (responseData?.status) {
        if (responseData) {
          responseData = decryptDataFromArray(responseData);
        }

        const { status, data } = responseData || {};
        if (status) {
          const jobTitleList = data?.allJobs;
          const jobs = Array.isArray(jobTitleList);

          if (jobs) {
            const jobdata = jobTitleList.map(item => ({
              id: item?.id,
              label: item?.job_title,
              value: item?.job_title,
            }));
            // setJobTitle(jobdata || []);
            setJobTitleData(jobTitleList || []);
          }
        }
      }
    } catch (err) {
      console.error("Error fetching Position Level data:", err);
    }
  };

  const fetchCityData = () => {
    let language = localStorage.getItem("lang_id");
    api
      .get(
        `${process.env.REACT_APP_API_URL}/getcity/city-listing?language_id=${language}`,
      )
      .then(response => {
        const allCity = response.data.cities;
        let data = allCity?.map(item => ({
          id: item?.id,
          label: item?.city,
          value: item?.city,
        }));
        setCity(data);
      })
      .catch(err => { });
  };

  const fetchAllCityLocations = () => {
    let language = localStorage.getItem("lang_id");
    api
      .get(
        `${process.env.REACT_APP_API_URL}/getcity/location-listing?language_id=${language}`
      )
      .then(response => {
        let responseData = response?.data;
        responseData = decryptDataFromArray(responseData);

        let allCityLocations = responseData?.allLocations || [];
        let groupedData = allCityLocations?.reduce((prev, curr) => {
          let currCity = curr?.city;
          let currCityOptions = prev?.[currCity]?.options || [];
          currCityOptions.push(curr);
          prev[currCity] = {
            label: currCity,
            options: currCityOptions,
          };

          return prev;
        }, {});
        groupedData = Object.values(groupedData);

        setAllCityLocations(groupedData);
      })
      .catch(err => { });
  };
  const fetchAllFranchiseWithLocations = () => {
    api
      .get(
        `${process.env.REACT_APP_API_URL}/admin/Franchise/list-with-location`,
      )
      .then(response => {
        const responseData = decryptDataFromArray(response?.data);
        const franchiseList = responseData?.data || [];

        setFranchiseList(franchiseList);

        if (!franchiseList.length) return;

        const defaultFranchise = franchiseList[0];
        const defaultLocations = defaultFranchise.locationList || [];

        setAllFranchiseLocations(defaultLocations);
        setSelectedFranchiseLocations(defaultLocations);

        setStatePayload(prev => ({
          ...prev,
          franchise_id: defaultFranchise.id,
          franchise_location_id: defaultLocations.map(loc => loc.id),
        }));
      })
      .catch(err => {
        console.error("Error fetching franchise list", err);
      });
  };

  const fetchAllDepartments = async () => {
    let language_id = localStorage.getItem("lang_id") || 1;
    await api
      .get(
        `${process.env.REACT_APP_API_URL}/admin/job/all-departments?language_id=${language_id}`,
      )
      .then(response => {
        let responseData = response?.data;
        responseData = decryptDataFromArray(responseData);
        let allDepartments = responseData?.data?.allDepartments || [];
        setAllDepartments(allDepartments);
      })
      .catch(err => {
        setAllDepartments([]);
      });
  };

  const fetchRoundsData = async () => {
    await getRoundsData()
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);

        if (responseData?.status) {
          setRoundList(responseData?.data);
          setAllRoundList(responseData?.data);
        } else {
          toast.error("No data available");
          setRoundList([]);
          setAllRoundList([]);
        }
      })
      .catch(err => {
        toast.error("No data Available");
        setRoundList([]);
        setAllRoundList([]);
      });
  };

  const fetchCompanyData = () => {
    api
      .get(`${process.env.REACT_APP_API_URL}/admin/company/fetch-company`)
      .then(response => {
        let responseData = response?.data;
        responseData = decryptDataFromArray(responseData);

        const { success, allCompany } = responseData || {};

        if (success) {
          let data = allCompany?.map(item => ({
            id: item?.id,
            label: item?.company_name,
            value: item?.id,
          }));
          // setCompany(data);
        }
      })
      .catch(err => { });
  };

  const fetchAllSkills = async () => {
    await getAllSkills()
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);
        let allSkills = responseData?.data?.companySkills || [];
        allSkills = allSkills?.map(skill => ({
          value: skill?.id,
          label: skill?.name,
          ...skill,
        }));
        setAllSkills(allSkills);
        setAllSavedSkills(allSkills);
      })
      .catch(err => {
        toast.error("No skills Available");
        setAllSkills([]);
      });
  };
  const getInterviewerList = async () => {
    await fetchinterViewers()
      .then(res => {
        let { userList, success } = decryptDataFromArray(res);
        let data = userList?.map(item => ({
          id: item?.id,
          label: item?.name,
          value: item?.id,
        }));
        setInterviewerList(data);
      })
      .catch(err => { });
  };

  const getCompanyData = async () => {
    await GetCompanyData()
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);
        setCompany(responseData?.data);
        let jobOption =
          responseData?.data?.vacancy_modes?.map(vacancyMode => ({
            value: vacancyMode,
            label: vacancyMode,
          }))[0] || null;
        setSelectedNumberOfJobOptions(jobOption);

        setStatePayload(prevState => ({
          ...prevState,
          expected_time:
            responseData?.data?.company_name == "Mahindra" ? "Full-Time" : "",
          number_of_jobs: jobOption?.value || "",
        }));
      })
      .catch(err => {
        console.error("No data Available");
      });
  };

  useEffect(() => {
    if (vtypes.length && !statePayload?.vacancy_type_id) {
      const defaultType = vtypes.find(
        el => el.label === "Individual Contributor"
      );

      if (defaultType) {
        setStatePayload(prev => ({
          ...prev,
          vacancy_type_id: defaultType.id.toString(),
        }));
      }
    }
  }, [vtypes]);

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);
  useEffect(() => {
    getCompanyData();
    fetchVacancyTypeData();
    fetchCityData();
    fetchAllCityLocations();
    fetchAllFranchiseWithLocations();
    fetchAllDepartments();
    fetchCompanyData();
    fetchRoundsData();
    fetchAllSkills();
    getInterviewerList();
    fetchJobTitleeData();

    return () => { };
  }, []);
  const initialOrgDetails = {
    name: "",
    address: "",
  };
  const [selectedModeOfJob, setSelectedModeOfJob] = useState(null);
  const [selectedhiringpurpose, setSelectedhiringpurpose] = useState(null);
  const [selectedHardwarePolicy, setSelectedHardwarePolicy] = useState(null);
  const [selectedhiringtype, setSelectedhiringtype] = useState(null);
  const [selectedhiringoption, setSelectedhiringoption] = useState(null);
  const [organizationOptions, setOrganizationOptions] = useState([]);
  const [selectedOrganization, setSelectedOrganization] = useState(null);
  const [organizationspocOptions, setOrganizationSpocOptions] = useState([]);
  const [selectedOrganizationspoc, setSelectedOrganizationSpoc] =
    useState(null);
  const [selectedtimezone, setSelectedtimezone] = useState(null);
  const [timezoneList, setTimezoneList] = useState(null);
  const [orgDetails, setOrgDetails] = useState(initialOrgDetails);
  const [spocDetails, setSPOCDetails] = useState({});
  const [roundTemplates, setRoundTemplates] = useState([]);
  const [selectedRoundTemplate, setSelectedRoundTemplate] = useState(null);
  const [humanCloudProcessAMValues, setHumanCloudProcessAMValues] =
    useState(null);
  const [amValueErrors, setAMValueErrors] = useState(null);

  const handleChangeAMValues = (key, value) => {
    setHumanCloudProcessAMValues(prev => ({
      ...(prev || {}),
      [key]: value,
    }));
  };

  const allowedFileTypes = [
    "application/msword",
    "application/pdf",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];

  const handleAMFilesUpload = (e, key) => {
    if (!e?.target?.files?.length) {
      toast.error("No files uploaded");
      return;
    }

    if (e?.target?.files?.length > 10) {
      toast.error("Maximum 10 files can be uploaded");
      e.target.value = null;
      return;
    }

    let allFiles = Array.from(e?.target?.files);

    let isError = allFiles?.some(
      file => !allowedFileTypes?.includes(file?.type)
    );

    if (isError) {
      toast.error("Invalid File Type. Please upload a DOC or PDF file.");
      e.target.value = null;
      return;
    }

    handleChangeAMValues(key, allFiles);
    setUploadedFiles(prev => ({
      ...prev,
      [key]: allFiles,
    }));
  };

  const isHumanCloudProcessAppl = () =>
    selectedhiringpurpose?.value === "Human Cloud Process";

  useEffect(() => {
    fetchOrganizationData();
    fetchMasterTimezone();
    fetchAllRoundTemplates();
  }, []);

  const fetchOrganizationData = async () => {
    try {
      const response = await api.get(
        `${process.env.REACT_APP_API_URL}/admin/organization-spoc/options`,
        {
        }
      );

      let responseData = decryptDataFromArray(response?.data);

      const organizationList = responseData.options.map(item => ({
        id: item.id,
        label: item.label,
        value: item.value,
        organization_spocs: item.organization_spocs || [],
      }));

      setOrganizationOptions(organizationList);
    } catch (error) {
      console.error("Error fetching organization data:", error);
    }
  };

  const handleSaveClick = async () => {
    try {
      let errors = {};
      const nameRegex = /^[A-Za-z\s.]+$/;
      const addressRegex = /^[A-Za-z0-9\s\.,#\-]+$/;

      if (!orgDetails?.name?.trim()) {
        errors.name = t(`Organization.Name is required`);
      } else if (!nameRegex.test(orgDetails.name.trim())) {
        errors.name = t(`Organization.Name should contain only alphabets`);
      } else {
        errors.name = null;
      }

      if (!orgDetails?.address?.trim()) {
        errors.address = t(`Organization.Address is required`);
      } else if (!addressRegex.test(orgDetails.address.trim())) {
        errors.address = t(
          `Organization.Address should contain only alphanumeric characters`
        );
      } else {
        errors.address = null;
      }

      if (!!Object.values(errors).some(val => !!val)) {
        setErrors(errors);

        setTimeout(() => {
          setErrors({});
        }, 2500);

        return;
      }

      let reqBody = {
        name: orgDetails?.name?.trim(),
        address: orgDetails?.address?.trim(),
      };

      let response = await CreateNewOrganization(reqBody);

      let responseMsg =
        response?.data?.message || "Organization Created Successfully";

      toast.success(responseMsg);
      setIsOpen1(false);
      fetchOrganizationData();
      setOrgDetails(initialOrgDetails);
    } catch (error) {
      let errMsg =
        error?.response?.data?.message ||
        error?.response?.message ||
        error?.message ||
        "Error while creating organization";

      let errors = error?.response?.data?.errors || {};
      setErrors(errors);

      setTimeout(() => {
        setErrors({});
      }, 2500);

      toast.error(errMsg);
    }
  };

  const validateForm = () => {
    let newErrors = {};
    const nameRegex = /^[A-Za-z\s.]+$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const mobileRegex = /^\d{10,10}$/;

    if (!spocDetails?.name?.trim()) {
      newErrors.name = t("Organization.SPOC.Name is required");
    } else if (!nameRegex.test(spocDetails.name.trim())) {
      newErrors.name = t(
        "Organization.SPOC.Name should contain only alphabets"
      );
    }

    if (!spocDetails?.email_id?.trim()) {
      newErrors.email_id = t("Organization.SPOC.Email is required");
    } else if (!emailRegex.test(spocDetails.email_id.trim())) {
      newErrors.email_id = t("Organization.SPOC.Enter a valid email");
    }

    if (!spocDetails?.mobile_no?.trim()) {
      newErrors.mobile_no = t("Organization.SPOC.Mobile number is required");
    } else if (!mobileRegex.test(spocDetails.mobile_no.trim())) {
      newErrors.mobile_no = t(
        "Organization.SPOC.Enter a valid mobile number (10 digits)"
      );
    } else if (/^0{10}$/.test(spocDetails.mobile_no.trim())) {
      newErrors.mobile_no = t(
        "Organization.SPOC.Enter a valid mobile number (10 digits)"
      );
    }

    if (!spocDetails?.role?.trim()) {
      newErrors.role = t("Organization.SPOC.Role is required");
    } else if (!nameRegex.test(spocDetails.role.trim())) {
      newErrors.role = t(
        "Organization.SPOC.Role should contain only alphabets and spaces"
      );
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSpocsubmit = async () => {
    if (!validateForm()) return;

    try {
      let reqBody = {
        organization_id: statePayload?.organization_id,
        name: spocDetails?.name?.trim(),
        email_id: spocDetails?.email_id?.trim(),
        mobile_no: spocDetails?.mobile_no?.trim(),
        role: spocDetails?.role?.trim(),
      };

      let response = await CreateNewOrgSPOC(reqBody);
      let responseMsg = response?.data?.message || "SPOC Created Successfully";

      toast.success(responseMsg);
      setIsOpen2(false);
      await fetchOrganizationData();

      refreshOrganizationSPOC(statePayload?.organization_id);
    } catch (error) {
      let errMsg =
        error?.response?.data?.message ||
        error?.response?.message ||
        error?.message ||
        "Error while creating SPOC";

      let errorData = error?.response?.data?.errors || {};
      setErrors(errorData);

      toast.error(errMsg);
    }
  };

  const handleSelectorganization = selectedOrg => {
    setSelectedOrganization(selectedOrg);
    setStatePayload(prevState => ({
      ...prevState,
      organization_id: selectedOrg?.value,
    }));
    // Find selected organization from the full list
    const selectedOrgData = organizationOptions.find(
      org => org.id === selectedOrg.id
    );

    // Update the SPOC dropdown options based on the selected organization
    const filteredSpocs =
      selectedOrgData?.organization_spocs?.map(spoc => ({
        id: spoc.id,
        label: spoc.label,
        value: spoc.value,
      })) || [];

    setOrganizationSpocOptions(filteredSpocs);
    setSelectedOrganizationSpoc(null);
  };

  const refreshOrganizationSPOC = async organizationId => {
    try {
      // Ensure we fetch the latest organization data
      const response = await api.get(
        `${process.env.REACT_APP_API_URL}/admin/organization-spoc/options`,
        {
        }
      );

      let responseData = decryptDataFromArray(response?.data);

      const updatedOrgData = responseData.options.find(
        org => org.id === organizationId
      );

      const updatedSpocs =
        updatedOrgData?.organization_spocs?.map(spoc => ({
          id: spoc.id,
          label: spoc.label,
          value: spoc.value,
        })) || [];

      setOrganizationSpocOptions(updatedSpocs);
      setSelectedOrganizationSpoc(null); // Reset selected SPOC
    } catch (error) {
      console.error("Error refreshing SPOC list", error);
    }
  };

  const fetchMasterTimezone = async () => {
    try {
      const response = await api.get(
        `${process.env.REACT_APP_API_URL}/public/get-timezones`
      );
      const timezoneList = response.data.data.map(item => ({
        id: item.value,
        label: item.label,
        value: item.value,
      }));
      setTimezoneList(timezoneList);
    } catch (error) {
      console.error("Error fetching timezones:", error);
    }
  };

  const fetchAllRoundTemplates = async () => {
    try {
      let response = await FetchAllRoundTemplateOptions();

      let responseData = decryptDataFromArray(response);

      setRoundTemplates(responseData?.templateList || []);
    } catch (error) {
      setRoundTemplates([]);
    }
  };

  function checkIfRemote(mode) {
    return typeof mode === "string" && mode.toLowerCase().trim() === "remote";
  }
  const handleSelectMode = selectedModeOfJob => {
    setSelectedModeOfJob(selectedModeOfJob);
    setStatePayload(prevState => ({
      ...prevState,
      mode_of_job: selectedModeOfJob?.value,
    }));
    const isRemote_Job = checkIfRemote(selectedModeOfJob?.value);
    IsRemoteJOb(isRemote_Job); // calling your setter or handler
    if (isRemote_Job) {
      handleDeselectAllCities();
    }
  };
  const handleHiringPurpose = selectedhiringpurpose => {
    setSelectedhiringpurpose(selectedhiringpurpose);
    setStatePayload(prevState => ({
      ...prevState,
      hiring_purpose: selectedhiringpurpose?.value,
    }));
  };
  const handleHiringOption = selectedhiringoption => {
    setSelectedhiringoption(selectedhiringoption);
    setStatePayload(prevState => ({
      ...prevState,
      hiring_option: selectedhiringoption?.value,
    }));
  };

  const handleTimezone = selectedtimezone => {
    setSelectedtimezone(selectedtimezone);
    setStatePayload(prevState => ({
      ...prevState,
      timezone_id: selectedtimezone?.value,
    }));
  };

  const handleHardwarePolicyChange = selectedHardwarePolicy => {
    setSelectedHardwarePolicy(selectedHardwarePolicy);
    setStatePayload(prevState => ({
      ...prevState,
      hardwarePolicy: selectedHardwarePolicy?.value,
    }));
  };

  const handleHiringType = selectedhiringtype => {
    setSelectedhiringtype(selectedhiringtype);
    setStatePayload(prevState => ({
      ...prevState,
      hiring_type: selectedhiringtype?.value,
    }));
  };

  const handleSelectorganizationSpoc = selectedOrganizationspoc => {
    setSelectedOrganizationSpoc(selectedOrganizationspoc);
    setStatePayload(prevState => ({
      ...prevState,
      organizationspoc_id: selectedOrganizationspoc?.value,
    }));
  };

  const [selectedNumberOfJobsOption, setSelectedNumberOfJobOptions] =
    useState(null);
  const handleNumberOfJobs = selectedNumberOfJobsOption => {
    setSelectedNumberOfJobOptions(selectedNumberOfJobsOption);
    setStatePayload(prevState => ({
      ...prevState,
      number_of_jobs: selectedNumberOfJobsOption?.value,
    }));
  };

  const [selectedCities, setSelectedCities] = useState([]);
  const handleSelectAllCities = () => {
    setSelectedCities(City);
    const allCityValues = City?.map(city => city.id);
    setStatePayload(prevState => ({
      ...prevState,
      city_id: allCityValues,
    }));
  };

  const handleDeselectAllCities = () => {
    setSelectedCities([]);
    setSelectedCityLocations([]);

    setStatePayload(prevState => ({
      ...prevState,
      city_id: [],
      location_id: [],
    }));
  };

  const handleChangeCity = selectedCities => {
    if (!selectedCities?.length) {
      handleDeselectAllCities();

      return;
    }

    setSelectedCities(selectedCities);
    const allCityValues = selectedCities?.map(city => city.id);

    let tempLocations = selectedCityLocations?.filter(location =>
      selectedCities?.some(opt => opt?.label === location?.city)
    );
    setSelectedCityLocations(tempLocations);
    let allLocationValues = tempLocations?.map(location => location?.id);

    setStatePayload(prevState => ({
      ...prevState,
      city_id: allCityValues,
      location_id: allLocationValues,
    }));
  };

  const [selectedCityLocations, setSelectedCityLocations] = useState([]);
  const handleSelectAllCityLocations = () => {
    if (!selectedCities?.length) {
      handleDeselectAllCityLocations();

      return;
    }

    let tempLocations = allCityLocations?.filter(location =>
      selectedCities?.some(opt => opt?.label === location?.label)
    );

    setSelectedCityLocations(
      tempLocations?.reduce(
        (prev, curr) => [...prev, ...(curr?.options || [])],
        []
      )
    );
    let allLocationValues = tempLocations?.reduce(
      (prev, curr) => [...prev, ...curr?.options?.map(c => c?.id)],
      []
    );
    setStatePayload(prevState => ({
      ...prevState,
      location_id: allLocationValues,
    }));
  };

  const handleDeselectAllCityLocations = () => {
    setSelectedCityLocations([]);
    setStatePayload(prevState => ({
      ...prevState,
      location_id: [],
    }));
  };

  const handleChangeCityLocation = options => {
    setSelectedCityLocations(options);
    // let locationValues = options?.map(location => location?.id);
    let locationValues = options;
    setStatePayload(prevState => ({
      ...prevState,
      location_id: locationValues,
    }));
  };

  // const handleChangeCityLocation = options => {
  //   setSelectedCityLocations(options);
  //   let allLocation = [],
  //     locationValues;

  //   options?.map(location => {
  //     locationValues = location?.options;
  //     allLocation = [...allLocation, ...locationValues];
  //   });

  //   setStatePayload(prevState => ({
  //     ...prevState,
  //     location_id: allLocation,
  //   }));
  // };

  const [selectedFranchiseLocations, setSelectedFranchiseLocations] = useState(
    []
  );
  const handleSelectAllFranchiseLocations = () => {
    if (!statePayload?.franchise_id) {
      handleDeselectAllFranchiseLocations();

      return;
    }

    setSelectedFranchiseLocations(allFranchiseLocations);
    let allLocationValues = allFranchiseLocations?.map(loc => loc?.id);

    setStatePayload(prevState => ({
      ...prevState,
      franchise_location_id: allLocationValues,
    }));
  };

  const handleDeselectAllFranchiseLocations = () => {
    setSelectedFranchiseLocations([]);
    setStatePayload(prevState => ({
      ...prevState,
      franchise_location_id: [],
    }));
  };

  const handleChangeFranchiseLocation = options => {
    setSelectedFranchiseLocations(options);

    let locationValues = options?.map(location => location?.id);
    setStatePayload(prevState => ({
      ...prevState,
      franchise_location_id: locationValues,
    }));
  };

  const [selectedDepts, setSelectedDepts] = useState([]);

  const handleSelectAllDepts = () => {
    setSelectedDepts(allDepartments);

    let allDeptValues = allDepartments?.map(dept => dept?.id);

    setStatePayload(prevState => ({
      ...prevState,
      department_id: allDeptValues,
    }));
  };

  const handleDeselectAllDepts = () => {
    setSelectedDepts([]);

    setStatePayload(prevState => ({
      ...prevState,
      department_id: [],
    }));
  };

  const handleChangeDept = (options = []) => {
    if (formFields?.jobTitle?.visible) {
      options = options.slice(-1);
    }
    setSelectedDepts(options || []);

    let allDeptValues = options?.map(dept => dept?.id) || [];

    let filteredJobTitle = [];
    if (formFields?.jobTitle?.visible) {
      jobTitledata.forEach(item => {
        if (allDeptValues.includes(item.departmentDetails.id)) {
          filteredJobTitle.push({
            id: item.id,
            label: item.job_title,
            value: item.job_title,
          });
        }
      });


      setJobTitle(filteredJobTitle);
      setStatePayload(prevState => ({
        ...prevState,
        job_id: null,
        title: "",
        description: "",
      }));
    }

    setStatePayload(prevState => ({
      ...prevState,
      department_id: allDeptValues,
    }));
  };

  const handleAddRound = roundItem => {
    let roundsList = [...roundList];
    roundsList = roundsList?.filter(el => el?.value !== roundItem?.value);
    let selectedList = [...selectedRounds];
    if (roundItem?.alias === "pre-assessment") {
      selectedList.unshift({ ...roundItem });
    } else {
      selectedList.push({ ...roundItem });
    }
    setSelectedRounds(selectedList);
    setRoundList(roundsList);
  };

  const handleRemoveRound = roundItem => {
    let roundsList = [...roundList];
    roundsList.push({ ...roundItem });
    let selectedList = [...selectedRounds];
    selectedList = selectedList?.filter(el => el?.value !== roundItem?.value);
    setSelectedRounds(selectedList);
    setRoundList(roundsList);
  };

  // Appending buttons to the options list
  const extendedCityOptions = [
    // {
    //   value: "buttons",
    //   label: (
    //     <div className="d-flex gap-2  select-all-menu">
    //       <div className="d-flex align-items-center gap-2">
    //         <div class="form-check mb-0">
    //           <input
    //             class="form-check-input"
    //             type="checkbox"
    //             value=""
    //             id="selectAllCheckbox"
    //             onChange={handleSelectAllCities}
    //           />
    //           <label class="form-check-label" for="flexCheckDefault">
    //             Select All
    //           </label>
    //         </div>
    //       </div>

    //       <div className="d-flex align-items-center gap-2">
    //         <div class="form-check mb-0">
    //           <input
    //             class="form-check-input"
    //             type="checkbox"
    //             value=""
    //             id="selectAllCheckbox"
    //             onChange={handleDeselectAllCities}
    //           />
    //           <label class="form-check-label" for="flexCheckDefault">
    //             Deselect All
    //           </label>
    //         </div>
    //       </div>
    //     </div>
    //   ),
    //   isDisabled: true,
    // },
    ...City,
  ];

  let location_list = [];
  allCityLocations.forEach(location => {
    if (selectedCities?.some(opt => opt?.label === location?.label)) {
      location?.options.forEach(elem => {
        location_list.push(elem);
      });
    }
    // return location;
  });

  const extendedCityLocationOptions = [
    // {
    //   value: "buttons",
    //   label: (
    //     <div className="d-flex flex-column gap-2">
    //       <div className="d-flex align-items-center gap-2">

    //         <div class="form-check mb-0">
    //           <input
    //             class="form-check-input"
    //             type="checkbox"
    //             value=""
    //             id="selectAllCheckbox"
    //             onChange={handleSelectAllCityLocations}
    //           />
    //           <label class="form-check-label" for="flexCheckDefault">
    //             Select All
    //           </label>
    //         </div>
    //       </div>
    //       <div className="d-flex align-items-center gap-2">

    //         <div class="form-check mb-0">
    //           <input
    //             class="form-check-input"
    //             type="checkbox"
    //             value=""
    //             id="selectAllCheckbox"
    //             onChange={handleDeselectAllCityLocations}
    //           />
    //           <label class="form-check-label" for="flexCheckDefault">
    //             Deselect All
    //           </label>
    //         </div>
    //       </div>
    //     </div>
    //   ),
    //   isDisabled: true,
    // },

    ...location_list,
    // ...allCityLocations?.filter(location =>
    //   selectedCities?.some(opt => opt?.label === location?.label)
    // ),
  ];

  const extendedFranchiseLocationOptions = [
    // {
    //   value: "buttons",
    //   label: (
    //     <div className="d-flex gap-2">
    //       <button
    //         className="selectall-btn"
    //         onClick={handleSelectAllFranchiseLocations}
    //       >
    //         Select All
    //       </button>
    //       <button
    //         className="selectall-btn"
    //         onClick={handleDeselectAllFranchiseLocations}
    //       >
    //         Deselect All
    //       </button>
    //     </div>
    //   ),
    //   isDisabled: true,
    // },
    ...allFranchiseLocations,
  ];

  const extendedDeptOptions = [
    // {
    //   value: "buttons",
    //   label: (
    //     <div className="d-flex gap-2 d-none">
    //       <button className="selectall-btn" onClick={handleSelectAllDepts}>
    //         Select All
    //       </button>
    //       <button className="selectall-btn" onClick={handleDeselectAllDepts}>
    //         Deselect All
    //       </button>
    //     </div>
    //   ),
    //   isDisabled: true,
    // },
    ...allDepartments,
  ];

  const extendedOptions1 = [
    {
      value: "Onsite",
      label: "Onsite",
    },
    {
      value: "Hybrid",
      label: "Hybrid",
    },
    {
      value: "Remote",
      label: "Remote",
    },
  ];

  const hiringpurposeoption =
    subdomain === "mahindra"
      ? [
        {
          value: "Internal",
          label: "Internal",
        },
      ]
      : [
        {
          value: "Internal",
          label: "Internal",
        },
        {
          value: "Human Cloud Process",
          label: "Human Cloud Process",
        },
      ];
  const hiringoption = [
    {
      value: "Onshore",
      label: "Onshore",
    },
    {
      value: "Offshore ",
      label: "Offshore ",
    },
  ];
  const hardwarePolicyOptions = [
    {
      value: "Client-provided",
      label: "Client Provided",
    },
    {
      value: "Neuronimbus-provided devices ",
      label: "Neuronimbus Provided Devices ",
    },
  ];
  const hiringTypeOptions = [
    {
      value: "direct-hiring",
      label: "Direct Hiring",
    },
    {
      value: "contract-based-hiring",
      label: "Contract Based Hiring",
    },
    {
      value: "third-party-talent-sourcing",
      label: "Third Party Talent Sourcing",
    },
  ];
  const extendedOptions2 = [
    {
      value: "Limited",
      label: "Limited",
    },
    {
      value: "Evergreen",
      label: "Evergreen",
    },
  ];


  const statusUpdateOptions = [
    {
      label: <>{t(`job-list.baseTag`)}</>,
      value: "",
    },
    {
      label: (
        <>
          <img src={pending_icon} alt="" /> {t(`job-list.Pending`)}
        </>
      ),
      value: "0",
    },
    {
      label: (
        <>
          <img src={progress_icon} alt="" /> {t(`job-list.Approve`)}
        </>
      ),
      value: "1",
    },
    {
      label: (
        <>
          <img src={screening_icon} alt="" /> {t(`job-list.Post`)}
        </>
      ),
      value: "2",
    },
    {
      label: (
        <>
          <img src={action3} alt="" /> {t(`job-list.Reject`)}
        </>
      ),
      value: "3",
    },
  ];

  const handleContentGeneration = async () => {
    // setContentLoading(true);
    let skills = selectedSkills?.map(skill => skill?.label)?.join(",");
    let cities = selectedCities?.map(el => el?.label)?.join(",");
    let departments = selectedDepts?.map(dept => dept?.label)?.join(",");
    let errorObj = {};
    if (isEmpty(statePayload?.title)) {
      errorObj = {
        ...errorObj,
        title: "Title is Required!",
      };
    }
    if (isEmpty(statePayload?.vacancy_type_id)) {
      errorObj = {
        ...errorObj,
        vacancy_type_id: "Position Level is Required!",
      };
    }
    console.log(errorObj,"errorObj")
        console.log(statePayload,"statePayload")
        console.log(statePayload,"statePayload")
    if (!isRemoteJOb) {
      if (statePayload?.location_mapped_with === "franchise") {
        // if (isEmpty(statePayload?.franchise_id)) {
        //   errorObj = {
        //     ...errorObj,
        //     franchise_id: "Dealership is Required!",
        //   };
        // }
        if (
  statePayload?.franchise_id === undefined ||
  statePayload?.franchise_id === null ||
  statePayload?.franchise_id === ""
) {
  errorObj = {
    ...errorObj,
    franchise_id: "Dealership is Required!",
  };
}
      } else {
        if (isEmpty(statePayload?.city_id)) {
          errorObj = {
            ...errorObj,
            city_id: "City is Required!",
          };
        }
      }
    }
    if (isEmpty(statePayload?.department_id)) {
      errorObj = {
        ...errorObj,
        department_id: "Department is Required!",
      };
    }
    if (isEmpty(statePayload?.mode_of_job)) {
      errorObj = {
        ...errorObj,
        mode_of_job: "Mode of Job is Required!",
      };
    }
    if (isEmpty(statePayload?.number_of_jobs)) {
      errorObj = {
        ...errorObj,
        number_of_jobs: "Number of Vacancies is Required!",
      };
    }
    // if (isEmpty(statePayload?.number_of_openings)) {
    //   errorObj = {
    //     ...errorObj,
    //     number_of_jobs: "Number of openings is Required!",
    //   };
    // }
    if (isEmpty(statePayload?.qualification)) {
      errorObj = {
        ...errorObj,
        qualification: "Qualification is Required!",
      };
    }
    if (isEmpty(statePayload?.experience)) {
      errorObj = {
        ...errorObj,
        experience: "Experience is Required!",
      };
    }
    // if (skills.length === 0) {
    //   errorObj = {
    //     ...errorObj,
    //     skills: "Skills are Required!",
    //   };
    // }
console.log("Final Error Object", errorObj);
console.log(statePayload,"statePayload");
    if (Object.keys(errorObj)?.length > 0) {
      setErrors(errorObj);
      setContentLoading(false);
      toast.error("Please fill required fields!");
      return false;
    }
    toast.success(
      `Please wait a moment for the description to be generated by AI.`
    );

    let descriptionPrompt = `Generate HTML Page Job application details with description for ${statePayload?.title} having the skills ${skills} with Position - ${statePayload?.title}, Experience - ${statePayload?.experience}, Location - ${cities}, Expected Time - ${statePayload?.expected_time}, Qualification - ${statePayload?.qualification}, Department - ${departments}`;

    let encryptedQuery = encryptDataToArray(descriptionPrompt);

    let payload = {
      prompt: encryptedQuery,
    };
    let resp = await generateDescriptionHelper(payload)
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);

        let content = responseData?.description || "";

        setStatePayload(prevState => ({
          ...prevState,
          ["description"]: content,
        }));

        toast.success("Description Generated Successfully.");
        setContentLoading(false);
      })
      .catch(err => {
        let errMsg =
          err?.response?.data?.message ||
          err?.message ||
          "Error while generating description";

        setContentLoading(false);
        toast.error(errMsg);
      });
  };

  const handleContentGenerationOfSkill = async () => {
    setContentLoading(true);

    let department = selectedDepts?.map(dept => dept?.label)?.join(",");

    let errorObj = {};
    if (isEmpty(statePayload?.title)) {
      errorObj = {
        ...errorObj,
        title: "Title is Required!",
      };
    }
    if (isEmpty(statePayload?.department_id)) {
      errorObj = {
        ...errorObj,
        department_id: "Department is Required!",
      };
    }
    if (isEmpty(statePayload?.qualification)) {
      errorObj = {
        ...errorObj,
        qualification: "Qualification is Required!",
      };
    }
    if (Object.keys(errorObj)?.length > 0) {
      setErrors(errorObj);
      setContentLoading(false);
      toast.error("Please fill required fields!");
      return false;
    }
    toast.success(`Please wait a moment for the skills to be generated by AI.`);

    let payload = {
      job_title: statePayload?.title,
      industry: department,
      experience_level: statePayload?.experience,
    };
    let response = await generateSkills(payload);

    let responseData = response?.data;
    if (responseData?.status == "success" || responseData?.status == 200) {
      let existingSkills = responseData?.existingSkills || [];
      let newSkills = responseData?.newSkills || [];

      let uniqueSkills = [...new Set([...existingSkills, ...newSkills])];
      const content = uniqueSkills.map(val => ({ label: val }));

      setSkills(content?.slice(0, 10));
      toast.success("Skills Generated Successfully.");
      setContentLoading(false);
    } else {
      let errMsg = "Error while generating Skills";
      setContentLoading(false);
      toast.error(errMsg);
    }
  };

  const handleSelectInterviewer = (e, ind) => {
    const value = Array.isArray(e)
      ? e.map(val => val.value).toString()
      : e?.value;

    setSelectedRounds(prev =>
      prev.map((round, index) =>
        index === ind ? { ...round, interviewer_id: value } : round
      )
    );
  };

  const handleSelectInterviewType = (e, ind) => {
    setSelectedRounds(prev =>
      prev.map((round, index) =>
        index === ind ? { ...round, meeting_type: e?.value } : round
      )
    );
  };

  const handleScoreThreshold = (e, ind) => {
    setSelectedRounds(prev =>
      prev.map((round, index) =>
        index === ind ? { ...round, score_threshold: e } : round
      )
    );
  };


  const dropdownRef = useRef(null);
  const [selectedValues, setSelectedValues] = useState([0, 30]);

  const breakpoints = [0, 5, 10, 15, 20, 25, 30];

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSliderChange = e => {
    // let [minValue, maxValue] = e;
    const minValue = e[0];
    const maxValue = e[1];
    setSelectedValues([minValue, maxValue]);
    setStatePayload(prevState => ({
      ...prevState,
      experience:
        minValue && maxValue
          ? `${minValue}-${maxValue} years`
          : `${maxValue ? maxValue : minValue} years`,
      min_exp: minValue,
      max_exp: maxValue,
    }));
  };

  const getNearestBreakpoint = value => {
    return breakpoints.reduce((prev, curr) => {
      return Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev;
    });
  };

  //skil

  const [isOpen, setIsOpen] = useState(false);

  const handleAddSkillClick = event => {
    event.preventDefault(); // Prevent default behavior, if applicable
    event.stopPropagation(); // Prevents the event from bubbling up the DOM

    setIsOpen(prev => !prev); // Toggle the dropdown/modal
  };

  //job-Description
  const [jobDescription, setJobDescription] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const [heading, setHeading] = useState("Upload File");
  const handleJobDescriptionChange = value => {
    setJobDescription(value);
  };

  // user
  const userInfo = getUserInfo();

  const handleFileChange = event => {
    const file = event.target.files[0];
    if (file) {
      setUploadedFile(file);
      setHeading("File Uploaded!");
    }
  };

  // Function to move round to selected
  const handleRoundClick = round => {
    // Remove round from available and add to selected
    setAvailableRounds(availableRounds.filter(r => r !== round));
    setSelectedRounds([...selectedRounds, round]);
  };

  // Function to remove a selected round and move it back to available
  const handleDeleteRound = round => {
    setSelectedRounds(selectedRounds.filter(r => r !== round));
    setAvailableRounds([...availableRounds, round]);
  };

  //step-----3-----
  //form-last
  //---------------//
  const [errors, setErrors] = useState({}); // Initialize error state

  // Handle input changes
  const handleInput = ({ target }) => {
    const { name, value } = target;
    if (
      name === "number_of_openings" &&
      value !== "" &&
      (isNaN(Number(value)) || Number(value) <= 0 || Number(value) > 25)
    ) {
      setErrors(prev => ({
        ...prev,
        number_of_openings: "Number of openings should be between 1 and 25!",
      }));
      return;
    } else if (name === "number_of_openings") {
      setErrors(prev => ({ ...prev, number_of_openings: null }));
    }

    if (name === "engagement_duration" && !/^\d*$/.test(value)) {
      setErrors(prev => ({
        ...prev,
        engagement_duration: "Only numeric values are allowed",
      }));
      return;
    } else if (name === "engagement_duration") {
      setErrors(prev => ({ ...prev, engagement_duration: null }));
    }
    setStatePayload(prev => ({ ...prev, [name]: value }));

    // Example validation
    if (name === "status" && value === "0") {
      setErrors({ ...errors, status: "Status is required" });
    } else if (name === "status") {
      setErrors({ ...errors, status: null });
    }
  };

  const [budgetRange, setBudgetRange] = useState([0, 10000]);

  const handleSliderChange2 = e => {
    const [minValue, maxValue] = e;
    setStatePayload(prevState => ({
      ...prevState,
      min_salary: minValue,
      max_salary: maxValue,
    }));
  };

  const handleCloseClick = () => {
    setIsOpen(false); // Close the dropdown/modal
  };
  const createNewJob = async formData => {
    const token = authHeader();
    await api
      .post(`${process.env.REACT_APP_API_URL}/admin/job/create-job`, formData, {
        headers: {
          Authorization: token,
          "Content-Type": "multipart/form-data",
        },
      })
      .then(response => {
        setIsLoading(false);
        toast.success("Job created successfully");
        history.push("/job-list");
      })
      .catch(err => {
        setIsLoading(false);
        toast.error(err?.response?.data?.message || "Something Went Wrong.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const handleSubmit = async event => {
    event.preventDefault();
    if (validateStep3()) {
      setErrors({});
      setIsLoading(true);

      let round_list = selectedRounds?.map(el => el?.value) || [];

      let skillIds =
        skills.filter(skill => !!skill.id).map(skill => skill.id) || [];
      let createdSkills =
        skills.filter(skill => !skill.id).map(skill => skill.label) || [];

      let company_id;

      if (statePayload?.company_id == undefined) {
        company_id = localStorage.getItem("subdomainId");
      } else {
        company_id = statePayload?.company_id;
      }

      const selectedPlatforms = Object.keys(checkedPlatforms).filter(
        platform => platform !== "all" && checkedPlatforms[platform]
      );

      let payload = {
        title: statePayload?.title,
        description: statePayload?.description,
        qualification: statePayload?.qualification,
        hiring_purpose: statePayload?.hiring_purpose,
        organization_id: statePayload?.organization_id,
        organizationspoc_id: statePayload?.organizationspoc_id,
        hiring_option: statePayload?.hiring_option,
        engagement_duration: statePayload?.engagement_duration,
        hardwarePolicy: statePayload?.hardwarePolicy,
        shift_start: statePayload?.shift_start,
        shift_end: statePayload?.shift_end,
        timezone_id: statePayload?.timezone_id,
        hiring_type: statePayload?.hiring_type,
        round_template_id: selectedRoundTemplate?.value,
        skillIds: JSON.stringify(skillIds),
        createdSkills: JSON.stringify(createdSkills),
        experience: statePayload?.experience,
        vacancy_type_id: statePayload?.vacancy_type_id,
        expected_time: statePayload?.expected_time,
        status: statePayload?.status,
        license: statePayload?.license,
        location_mapped_with: statePayload?.location_mapped_with || "city",
        // city_id: statePayload?.city_id?.join(","),
        city_id: Array.isArray(statePayload?.city_id)
          ? statePayload.city_id.join(",")
          : "",

        location_id:
          Array.isArray(statePayload?.location_id) &&
            statePayload.location_id.length > 0
            ? statePayload?.location_id
            : selectedCityLocations?.map(location => ({
              location_id: location?.id,
              country_id: location?.country_id,
              region_id: location?.region_id,
              state_id: location?.state_id,
              city_id: location?.city_id,
            })),
        franchise_id: statePayload?.franchise_id,
        franchise_location_id: selectedFranchiseLocations?.map(loc => ({
          location_id: loc?.id,
          country_id: loc?.country_id,
          region_id: loc?.region_id,
          state_id: loc?.state_id,
          city_id: loc?.city_id,
        })),
        department_id: selectedDepts?.map(dept => dept?.id),
        mode_of_job: statePayload?.mode_of_job,
        number_of_jobs: statePayload?.number_of_jobs,
        number_of_openings: statePayload?.number_of_openings,
        min_salary: statePayload?.min_salary,
        max_salary: statePayload?.max_salary,
        relevance_score: statePayload?.relevance_score,
        video_analysis_score: statePayload?.video_analysis_score,
        video_analysis_ques: statePayload?.video_analysis_ques,
        round_list: JSON.stringify(round_list),
        company_id: company_id,
        interviewerRoundsData: selectedRounds,
        linkedin_status: jobStatus || "",
        platforms: selectedPlatforms,
        collaboration_tool: humanCloudProcessAMValues?.collaboration_tool,
        programming_languages: humanCloudProcessAMValues?.programming_languages,
        ide_preferences: humanCloudProcessAMValues?.ide_preferences,
        version_control_systems:
          humanCloudProcessAMValues?.version_control_systems,
        timesheet_process: humanCloudProcessAMValues?.timesheet_process,
        billing_process: humanCloudProcessAMValues?.billing_process,
        timesheet_approval: !!humanCloudProcessAMValues?.timesheet_approval,
        billing_approval: !!humanCloudProcessAMValues?.billing_approval,
        completed_work_approval:
          !!humanCloudProcessAMValues?.completed_work_approval,
        parttime_type: partTimeType,
        application_startdate: startDate,
        job_id: statePayload.job_id,
        specialization: statePayload?.specialization?.trim() || "",
        specializationMap: statePayload?.specializationMap || [],
        relevant_experience: statePayload?.relevant_experience,
        female_candidates_preferred: statePayload?.female_candidates_preferred,
        min_exp: statePayload?.min_exp,
        max_exp: statePayload?.max_exp,
      };

      let formData = new FormData();

      formData.append("query", JSON.stringify(payload || {}));

      // if (humanCloudProcessAMValues?.contract_compliance_documents?.length) {
      //   for (let file of humanCloudProcessAMValues?.contract_compliance_documents ||
      //     []) {
      //     formData.append("contract_compliance_documents[]", file);
      //   }
      // }
      if (
        humanCloudProcessAMValues &&
        Array.isArray(humanCloudProcessAMValues.contract_compliance_documents)
      ) {
        for (let file of humanCloudProcessAMValues.contract_compliance_documents) {
          formData.append("contract_compliance_documents[]", file);
        }
      }

      // if (humanCloudProcessAMValues?.nda_ip_protection_agreements?.length) {
      //   for (let file of humanCloudProcessAMValues?.nda_ip_protection_agreements ||
      //     []) {
      //     formData.append("nda_ip_protection_agreements[]", file);
      //   }
      // }

      if (
        humanCloudProcessAMValues &&
        Array.isArray(humanCloudProcessAMValues.nda_ip_protection_agreements)
      ) {
        for (let file of humanCloudProcessAMValues.nda_ip_protection_agreements) {
          formData.append("nda_ip_protection_agreements[]", file);
        }
      }

      // Calling the api and saving data;
      await createNewJob(formData);
    }
  };
  //edit

  const [newSkill, setNewSkill] = useState("");
  const [query, setQuery] = useState("");

  const handleSearchChange = event => {
    let allSelectedSkills = allSkills.filter(item =>
      item?.label?.toLowerCase()?.includes(event.toLowerCase())
    );
    setAllSkills(allSelectedSkills);
  };

  // Event to remove skill auto population
  const handleKeyDown = event => {
    if (event?.key === "Backspace") {
      setAllSkills(allSavedSkills);
    }
  };

  const suggestedSkills = [
    "UI/UX Design",
    "Frontend Development",
    "Backend Development",
    "Project Management",
    "Data Analysis",
    // Add more suggested skills as needed
  ];

  const handleAddSkill = skill => {
    // Check if the skill is already in the skills array
    if (!skills.some(existingSkill => existingSkill.label === skill.label)) {
      let newSkill = {
        id: skill.value,
        label: skill.label,
      };

      // let total_skills = [...skills, newSkill]?.length;
      // if (total_skills > 10) {
      //   toast.error("You cannot add more than 10 skills.");

      //   return;
      // }
      setSkills([...skills, newSkill]);
    }
    setAllSkills(allSavedSkills);
  };

  const filteredSkills = allSkills.filter(
    skill => !skills.some(existingSkill => existingSkill.label === skill.label)
  );

  const handleAddCustomSkill = e => {
    e.preventDefault(); // Prevent default button behavior
    if (newSkill && !skills.includes(newSkill)) {
      let newSkillObj = {
        label: newSkill,
      };

      // let total_skills = [...skills, newSkillObj]?.length;
      // if (total_skills > 10) {
      //   toast.error("You cannot add more than 10 skills.");
      //   return;
      // }
      setSkills([...skills, newSkillObj]);
      setNewSkill("");
    }
    setAllSkills(allSavedSkills);
  };

  // Function to handle saving skills and closing the modal
  const handleSaveSkills = () => {
    // let total_skills = skills?.length;
    // if (total_skills > 10) {
    //   toast.error("You cannot add more than 10 skills.");
    //   return;
    // }
    setIsOpen(false);
  };

  const options = [
    { value: "0", label: "0" },
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
    { value: "6", label: "6" },
    { value: "7", label: "7" },
    { value: "8", label: "8" },
    { value: "9", label: "9" },
    { value: "10", label: "10" },
  ];
  const [selectedOptionMin, setSelectedOptionMin] = useState(null);
  const [selectedOptionMax, setSelectedOptionMax] = useState(null);
  const [isOpen1, setIsOpen1] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isJobDescModalOpen, setIsJobDescModalOpen] = useState(false);

  const handleMinExp = e => {
    setSelectedOptionMin({ value: e.target.value });
    setStatePayload({
      ...statePayload,
      min_exp: e.target.value,
    });
  };
  const handleMaxExp = e => {
    setSelectedOptionMax({ value: e.target.value });
  };
  const handleRelevantExperience = e => {
    setStatePayload({
      ...statePayload,
      relevant_experience: e.target.value,
    });
  };
  const UpdateEXP = () => {
    let obj = {
      minValue: selectedOptionMin?.value || "",
      maxValue: selectedOptionMax?.value || "",
    };
    handleSliderChange([obj.minValue, obj.maxValue]);
  };

  console.log(errors, "errors object")

  useEffect(() => {
    UpdateEXP();
  }, [selectedOptionMin, selectedOptionMax]);

  const [selectedOption1, setSelectedOption1] = useState(null);

  const handleChange1 = selected => {
    setSelectedOption1(selected);
  };

  const [isToggled, setIsToggled] = useState(false);

  const handleClick = e => {
    e.preventDefault(); // This stops the page from reloading
    setIsToggled(prevState => !prevState); // Toggles the state
  };

  const handleSelection = e => {
    setSelectedFruits(e.value || []);
  };
  if (!checkPermissionStatus("job-list", "create")) {
    return (
      <div className="page-content">
        <h4 className="text-center">Access Denied.</h4>
      </div>
    );
  }

  return (
    <div className="page-content  createjobnew">
      <Container fluid>
        <div className="joblist-container create-vacancy createjob-page">
          <Row className="mb-3 align-items-center justify-content-between">
            <Col lg="6" md="6">
              <Link to="/job-list">
                <h5 className="text-uppercase heading-one">
                  <img src={arrow_btn} alt="arrow_btn" />
                  Positions / Create Job
                </h5>
              </Link>
            </Col>

            <Col lg="6">
              <div className="bradcums-list-post">
                <ul className="step-indicator">
                  <li className={currentStep >= 1 ? "active-one" : ""}>1</li>
                  <li className={currentStep >= 2 ? "active-one" : ""}>2</li>
                  <li className={currentStep >= 3 ? "active-one" : ""}>3</li>
                  {isHumanCloudProcessAppl() ? (
                    <li className={currentStep >= 4 ? "active-one" : ""}>4</li>
                  ) : (
                    <></>
                  )}
                </ul>
              </div>
            </Col>
          </Row>
        </div>

        <div className="outerTab-box-wrapper below-vacancy createjob-page">
          <div className="form-details-section jobdetails">
            {/* Step/Preview */}
            {!formSubmitted ? (
              <Row>
                {currentStep === 1 && (
                  <>
                    <div className="heading-interview ">
                      <h2>Step 1: What job do you want to post?</h2>
                    </div>
                    {formFields?.department?.visible && (
                      <Col lg={4}>
                        <Form.Group className=" mb-4 floating-label">
                          <Form.Label className="float-label">
                            Department
                            <span class="text-danger">*</span>
                          </Form.Label>
                          <div
                            className="selectoption"
                            title={
                              selectedDepts && selectedDepts.length > 0
                                ? selectedDepts
                                  .map(dept => dept.label)
                                  .join(", ")
                                : "Select Department"
                            }
                          >
                            <MultiSelect
                              options={extendedDeptOptions}
                              value={selectedDepts}
                              onChange={handleChangeDept}
                              placeholder="Department"
                              placeholderText="Department"
                              aria-label="Select Department" // Use aria-label for accessibility
                              overrideStrings={{
                                selectSomeItems: "Department",
                              }}
                              hasSelectAll={
                                formFields?.jobTitle?.visible ? false : true
                              }
                            />
                          </div>
                          {selectedDepts?.length == 0 &&
                            errors?.department_id && (
                              <p className="text-danger">
                                {" "}
                                {errors?.department_id}{" "}
                              </p>
                            )}
                        </Form.Group>
                      </Col>
                    )}

                    {formFields?.jobTitle?.visible && (
                      <Col lg={4}>
                        <Form.Group className="mb-4 floating-label">
                          <Form.Label className="float-label">
                            Job Title<span className="text-danger">*</span>
                          </Form.Label>
                          <Select
                            name="job_id"
                            options={jobTitle} // 👈 should be array of { value, label }
                            value={
                              jobTitle?.find(
                                opt => opt.id === statePayload?.job_id
                              ) || null
                            }
                            onChange={selected =>
                              handleJobSelection(selected?.id)
                            }
                            placeholder="Select Job Title"
                            isSearchable
                          />
                          {!statePayload?.job_id && errors?.job_id && (
                            <p className="text-danger">{errors?.job_id}</p>
                          )}
                        </Form.Group>
                      </Col>
                    )}

                    {formFields?.designation?.visible && (
                      <Col lg={4}>
                        <Form.Group className="mb-4 floating-label">
                          <Form.Label className="float-label">
                            Job Title/Designation
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Write a clear title for more targeted and helpful replies"
                            name="title"
                            value={statePayload?.title}
                            onChange={handleInput}
                            title="Write a clear title for more targeted and helpful replies"
                          />
                          {!statePayload?.title && errors?.title && (
                            <p className="text-danger"> {errors?.title}</p>
                          )}
                        </Form.Group>
                      </Col>
                    )}
                    {isOpen1 && (
                      <>
                        <div className="modal-organization">
                          <button
                            className="btn btn-setopen1"
                            onClick={() => setIsOpen1(false)}
                          >
                            <img src={cross} alt="Close" />
                          </button>
                          <div className="modal-contents">
                            <Form.Group
                              className="mb-3"
                              controlId="exampleForm.ControlInput1"
                            >
                              <Form.Label className="float-label">
                                {t(`Organization.Name`)}
                                <span className="text-danger">*</span>
                              </Form.Label>
                              <Form.Control
                                placeholder={t(`Organization.Enter Name`)}
                                type="text"
                                name="name"
                                value={orgDetails?.name}
                                onChange={e => {
                                  setOrgDetails({
                                    ...orgDetails,
                                    name: e.target.value,
                                  });
                                  setErrors({
                                    ...errors,
                                    name: !!e?.target?.value?.trim()
                                      ? null
                                      : t("Organization.Name is required"),
                                  });

                                  setTimeout(() => {
                                    setErrors({
                                      ...errors,
                                      name: null,
                                    });
                                  }, 2500);
                                }}
                                title={t(`Organization.Name`)}
                              />
                              {errors?.name && (
                                <p className="text-danger">{errors?.name}</p>
                              )}
                            </Form.Group>
                            <Form.Group
                              className="mb-3"
                              controlId="exampleForm.ControlInput1"
                            >
                              <Form.Label className="float-label">
                                {t(`Organization.Address`)}
                              </Form.Label>
                              <Form.Control
                                rows="4"
                                as="textarea"
                                placeholder={t(`Organization.Enter Address`)}
                                name="address"
                                value={orgDetails?.address}
                                onChange={e => {
                                  setOrgDetails({
                                    ...orgDetails,
                                    address: e.target.value,
                                  });
                                }}
                                title={t(`Organization.Address`)}
                              />
                              {errors?.address && (
                                <p className="text-danger">{errors?.address}</p>
                              )}
                            </Form.Group>
                            <button
                              className="btn btn-primary reset mx-2"
                              onClick={() => {
                                setIsOpen1(false);
                              }}
                            >
                              {t(`Organization.Cancel`)}
                            </button>
                            <button
                              className="btn btn-primary"
                              onClick={() => handleSaveClick()}
                            >
                              {t(`Organization.Save`)}
                            </button>
                          </div>
                        </div>
                        <div class="backshadow-card"></div>
                      </>
                    )}
                    {formFields?.purposeOfHiring?.visible && (
                      <Col lg={4}>
                        <Form.Group className="mb-4 floating-label">
                          <Form.Label className="float-label">
                            Purpose of Hiring
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <div
                            title={
                              selectedhiringpurpose?.label ||
                              "Purpose of Hiring"
                            }
                          >
                            <Select
                              options={hiringpurposeoption}
                              value={
                                selectedhiringpurpose ||
                                hiringpurposeoption.find(
                                  opt => opt.value === "Internal"
                                )
                              }
                              onChange={handleHiringPurpose}
                              placeholder="Purpose of Hiring"
                              aria-label="Please Select Purpose of Hiring"
                            />
                          </div>
                          {!statePayload?.hiring_purpose &&
                            errors?.hiring_purpose && (
                              <p className="text-danger">
                                {" "}
                                {errors?.hiring_purpose}{" "}
                              </p>
                            )}
                        </Form.Group>
                      </Col>
                    )}
                    {isHumanCloudProcessAppl() && (
                      <>
                        <Col lg={4}>
                          <Form.Group className="mb-4 floating-label">
                            <Form.Label className="float-label create-org">
                              <div className="label-card">
                                Organization
                                <span className="text-danger">*</span>
                              </div>
                              <button
                                onClick={() => setIsOpen1(true)}
                                className="form-createjob"
                              >
                                Add Organization
                              </button>
                            </Form.Label>
                            <div
                              title={
                                selectedOrganization?.label || "Organization"
                              }
                            >
                              <Select
                                options={organizationOptions}
                                value={selectedOrganization}
                                onChange={handleSelectorganization}
                                placeholder="Organization"
                                aria-label="Please Select Organization"
                              />
                            </div>
                            {!statePayload?.organization_id &&
                              errors?.organization_id && (
                                <p className="text-danger">
                                  {errors.organization_id}
                                </p>
                              )}
                          </Form.Group>
                        </Col>
                        {isOpen2 && (
                          <>
                            <div className="modal-organization">
                              <button
                                className="btn btn-setopen1"
                                onClick={() => setIsOpen2(false)}
                              >
                                <img src={cross} alt="Close" />
                              </button>
                              <div className="modal-contents">
                                <Form.Group
                                  className="mb-3"
                                  controlId="exampleForm.ControlInput1"
                                >
                                  <div className="toggle-box">
                                    <Form.Group
                                      className="mb-3"
                                      controlId="exampleForm.ControlInput1"
                                    >
                                      <Form.Label className="float-label">
                                        {t(`Organization.SPOC.Name`)}
                                        <span className="text-danger">*</span>
                                      </Form.Label>
                                      <Form.Control
                                        placeholder={t(
                                          `Organization.SPOC.Enter Name`
                                        )}
                                        type="text"
                                        name="name"
                                        value={spocDetails?.name}
                                        onChange={e => {
                                          setSPOCDetails({
                                            ...spocDetails,
                                            name: e.target.value,
                                          });
                                          setErrors({
                                            ...errors,
                                            name: !!e?.target?.value?.trim()
                                              ? null
                                              : t(
                                                "Organization.SPOC.Name is required"
                                              ),
                                          });

                                          setTimeout(() => {
                                            setErrors({
                                              ...errors,
                                              name: null,
                                            });
                                          }, 2500);
                                        }}
                                        title={t(`Organization.SPOC.Name`)}
                                      />
                                      {errors?.name && (
                                        <p className="text-danger">
                                          {errors?.name}
                                        </p>
                                      )}
                                    </Form.Group>

                                    <Form.Group
                                      className="mb-3"
                                      controlId="exampleForm.ControlInput1"
                                    >
                                      <Form.Label className="float-label">
                                        {t(`Organization.SPOC.Email`)}
                                        <span className="text-danger">*</span>
                                      </Form.Label>
                                      <Form.Control
                                        placeholder={t(
                                          `Organization.SPOC.Enter Email`
                                        )}
                                        type="email"
                                        name="email_id"
                                        value={spocDetails?.email_id}
                                        onChange={e => {
                                          setSPOCDetails({
                                            ...spocDetails,
                                            email_id: e.target.value,
                                          });
                                          setErrors({
                                            ...errors,
                                            email_id: !!e?.target?.value?.trim()
                                              ? null
                                              : t(
                                                "Organization.SPOC.Email is required"
                                              ),
                                          });

                                          setTimeout(() => {
                                            setErrors({
                                              ...errors,
                                              email_id: null,
                                            });
                                          }, 2500);
                                        }}
                                        title={t(`Organization.SPOC.Email`)}
                                      />
                                      {errors?.email_id && (
                                        <p className="text-danger">
                                          {errors?.email_id}
                                        </p>
                                      )}
                                    </Form.Group>

                                    <Form.Group
                                      className="mb-3"
                                      controlId="exampleForm.ControlInput1"
                                    >
                                      <Form.Label className="float-label">
                                        {t(`Organization.SPOC.Mobile`)}
                                        <span className="text-danger">*</span>
                                      </Form.Label>
                                      <Form.Control
                                        placeholder={t(
                                          `Organization.SPOC.Enter Mobile No`
                                        )}
                                        type="tel"
                                        name="mobile_no"
                                        value={spocDetails?.mobile_no}
                                        onChange={e => {
                                          setSPOCDetails({
                                            ...spocDetails,
                                            mobile_no: e.target.value,
                                          });
                                          setErrors({
                                            ...errors,
                                            mobile_no:
                                              !!e?.target?.value?.trim()
                                                ? null
                                                : t(
                                                  "Organization.SPOC.Mobile number is required"
                                                ),
                                          });

                                          setTimeout(() => {
                                            setErrors({
                                              ...errors,
                                              mobile_no: null,
                                            });
                                          }, 2500);
                                        }}
                                        title={t(`Organization.SPOC.Mobile`)}
                                      />
                                      {errors?.mobile_no && (
                                        <p className="text-danger">
                                          {errors?.mobile_no}
                                        </p>
                                      )}
                                    </Form.Group>

                                    <Form.Group
                                      className="mb-3"
                                      controlId="exampleForm.ControlInput1"
                                    >
                                      <Form.Label className="float-label">
                                        {t(`Organization.SPOC.Role`)}
                                        <span className="text-danger">*</span>
                                      </Form.Label>
                                      <Form.Control
                                        placeholder={t(
                                          `Organization.SPOC.Enter Role`
                                        )}
                                        type="text"
                                        name="role"
                                        value={spocDetails?.role}
                                        onChange={e => {
                                          setSPOCDetails({
                                            ...spocDetails,
                                            role: e.target.value,
                                          });
                                        }}
                                        title={t(`Organization.SPOC.Role`)}
                                      />
                                      {errors?.role && (
                                        <p className="text-danger">
                                          {errors?.role}
                                        </p>
                                      )}
                                    </Form.Group>
                                  </div>
                                </Form.Group>

                                <button
                                  className="btn btn-primary reset mx-2"
                                  onClick={() => {
                                    setIsOpen2(false);
                                  }}
                                >
                                  {t(`Organization.SPOC.Cancel`)}
                                </button>
                                <button
                                  className="btn btn-primary search"
                                  onClick={() => handleSpocsubmit()}
                                >
                                  {t(`Organization.SPOC.Save`)}
                                </button>
                              </div>
                            </div>
                            <div class="backshadow-card"></div>
                          </>
                        )}
                        <Col lg={4}>
                          <Form.Group className="mb-4 floating-label">
                            <Form.Label className="float-label create-org">
                              <div className="label-card">
                                Organization SPOC
                                <span className="text-danger">*</span>
                              </div>

                              {statePayload?.organization_id && (
                                <button
                                  onClick={() => setIsOpen2(true)}
                                  className="form-createjob"
                                >
                                  Add Organization SPOC
                                </button>
                              )}
                            </Form.Label>
                            <div
                              title={
                                selectedOrganizationspoc?.label ||
                                "Organization"
                              }
                            >
                              <Select
                                options={organizationspocOptions}
                                value={selectedOrganizationspoc}
                                onChange={handleSelectorganizationSpoc}
                                placeholder="Organization SPOC"
                                aria-label="Please Select Organization SPOC"
                              />
                            </div>
                            {!statePayload?.organizationspoc_id &&
                              errors?.organizationspoc_id && (
                                <p className="text-danger">
                                  {errors.organizationspoc_id}
                                </p>
                              )}
                          </Form.Group>
                        </Col>

                        <Col lg={4}>
                          <Form.Group className="mb-4 floating-label">
                            <Form.Label className="float-label">
                              Human Cloud Hiring Option
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <div
                              title={
                                selectedhiringoption?.label ||
                                "Human Cloud Hiring Option"
                              }
                            >
                              <Select
                                options={hiringoption}
                                value={selectedhiringoption}
                                onChange={handleHiringOption}
                                placeholder="Human Cloud Hiring Option"
                                aria-label="Please Select Human Cloud Hiring Option"
                              />
                            </div>
                            {!statePayload?.hiring_option &&
                              errors?.hiring_option && (
                                <p className="text-danger">
                                  {errors.hiring_option}
                                </p>
                              )}
                          </Form.Group>
                        </Col>

                        <Col lg={4}>
                          <Form.Group className="mb-4 floating-label">
                            <Form.Label className="float-label">
                              Duration of Engagement
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Duration of Engagement"
                              name="engagement_duration"
                              value={statePayload?.engagement_duration || ""}
                              onChange={handleInput}
                              title="Please Enter Duration of Engagement"
                            />
                            {!statePayload?.engagement_duration &&
                              errors?.engagement_duration && (
                                <p className="text-danger">
                                  {errors.engagement_duration}
                                </p>
                              )}
                          </Form.Group>
                        </Col>
                        <Col lg={4}>
                          <Form.Group className="mb-4 floating-label">
                            <Form.Label className="float-label">
                              Hardware & Security
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <div
                              title={
                                selectedHardwarePolicy?.label ||
                                "Select Hardware & Security"
                              }
                            >
                              <Select
                                options={hardwarePolicyOptions}
                                value={selectedHardwarePolicy}
                                onChange={handleHardwarePolicyChange}
                                placeholder="Select Hardware & Security"
                                aria-label="Select Hardware & Security"
                              />
                            </div>
                            {!statePayload?.hardwarePolicy &&
                              errors?.hardwarePolicy && (
                                <p className="text-danger">
                                  {errors.hardwarePolicy}
                                </p>
                              )}
                          </Form.Group>
                        </Col>
                        <Col lg={4}>
                          <Form.Group className="mb-4 floating-label">
                            <Form.Label className="float-label">
                              Shift Start Time
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="time"
                              placeholder="Shift Start Time"
                              name="shift_start"
                              value={statePayload?.shift_start || ""}
                              onChange={handleInput}
                              title="Please Enter Shift Start Time"
                            />
                            {!statePayload?.shift_start &&
                              errors?.shift_start && (
                                <p className="text-danger">
                                  {errors.shift_start}
                                </p>
                              )}
                          </Form.Group>
                        </Col>
                        <Col lg={4}>
                          <Form.Group className="mb-4 floating-label">
                            <Form.Label className="float-label">
                              Shift End Time
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="time"
                              placeholder="Shift End Time"
                              name="shift_end"
                              value={statePayload?.shift_end || ""}
                              onChange={handleInput}
                              title="Please Enter Shift End Time"
                            />
                            {!statePayload?.shift_end && errors?.shift_end && (
                              <p className="text-danger">{errors.shift_end}</p>
                            )}
                          </Form.Group>
                        </Col>
                        <Col lg={4}>
                          <Form.Group className="mb-4 floating-label">
                            <Form.Label className="float-label">
                              Timezone<span className="text-danger">*</span>
                            </Form.Label>
                            <div title={selectedtimezone?.label || "Timezone"}>
                              <Select
                                options={timezoneList}
                                value={selectedtimezone}
                                onChange={handleTimezone}
                                placeholder="Timezone"
                                aria-label="Please Select Timezone"
                              />
                            </div>
                            {!statePayload?.timezone_id &&
                              errors?.timezone_id && (
                                <p className="text-danger">
                                  {errors.timezone_id}
                                </p>
                              )}
                          </Form.Group>
                        </Col>
                        <Col lg={4}>
                          <Form.Group className="mb-4 floating-label">
                            <Form.Label className="float-label">
                              Hiring Type
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <div
                              title={
                                selectedhiringoption?.label || "Hiring Type"
                              }
                            >
                              <Select
                                options={hiringTypeOptions}
                                value={selectedhiringtype}
                                onChange={handleHiringType}
                                placeholder="Hiring Type"
                                aria-label="Please Select Hiring Type"
                              />
                            </div>
                            {!statePayload?.hiring_type &&
                              errors?.hiring_type && (
                                <p className="text-danger">
                                  {errors.hiring_type}
                                </p>
                              )}
                          </Form.Group>
                        </Col>
                      </>
                    )}
                    {formFields?.positionLevel?.visible && (
                      <Col lg={4}>
                        <Form.Group className=" mb-4 floating-label">
                          <Form.Label className="float-label">
                            Position Level<span className="text-danger">*</span>
                          </Form.Label>
                          <select
                            type="select"
                            name="saas_parent"
                            className="col-md-6 mb-1 form-control form-select"
                            style={{ width: "100%" }}
                            value={statePayload?.vacancy_type_id || ""}
                            onChange={e =>
                              handleVtypeSelection(e.target?.value)
                            }
                            title={
                              vtypes.find(
                                v => v.id === statePayload?.vacancy_type_id
                              )?.label || "Please Select Position Level"
                            }
                          >
                            <option value="" selected>
                              Select Position Level
                            </option>
                            {vtypes &&
                              vtypes?.map(el => {
                                return (
                                  <option key={el?.value} value={el?.id}>
                                    {el?.label}
                                  </option>
                                );
                              })}
                          </select>
                          {!statePayload?.vacancy_type_id &&
                            errors?.vacancy_type_id && (
                              <p className="text-danger">
                                {" "}
                                {errors?.vacancy_type_id}{" "}
                              </p>
                            )}
                        </Form.Group>
                      </Col>
                    )}
                    {formFields?.modeOfJob?.visible && (
                      <Col lg={4}>
                        <Form.Group className="mb-4 floating-label">
                          <Form.Label className="float-label">
                            Mode of Job<span className="text-danger">*</span>
                          </Form.Label>
                          <div
                            title={selectedModeOfJob?.label || "Mode of Job"}
                          >
                            <Select
                              options={extendedOptions1}
                              value={
                                selectedModeOfJob ||
                                extendedOptions1.find(
                                  opt => opt.value === "Onsite"
                                )
                              }
                              onChange={handleSelectMode}
                              placeholder="Mode of Job"
                              aria-label="Please Select Mode of Job"
                            />
                          </div>
                          {!statePayload?.mode_of_job &&
                            errors?.mode_of_job && (
                              <p className="text-danger">
                                {" "}
                                {errors?.mode_of_job}{" "}
                              </p>
                            )}
                        </Form.Group>
                      </Col>
                    )}
                    {formFields?.vacancies?.visible && (
                      <Col lg={4} md="6">
                        <Form.Group className="mb-4 floating-label">
                          <Form.Label className="float-label">
                            Number of Vacancies
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <div
                            className="selectoption"
                            title={
                              selectedNumberOfJobsOption?.label ||
                              "Number of Vacancies"
                            }
                          >
                            <Select
                              options={company?.vacancy_modes?.map(
                                vacancyMode => {
                                  return {
                                    value: vacancyMode,
                                    label: vacancyMode,
                                  };
                                }
                              )}
                              isDisabled={formFields?.vacancies?.disabled}
                              value={selectedNumberOfJobsOption}
                              onChange={handleNumberOfJobs}
                              placeholder="Number of Vacancies"
                              aria-label="Select Number of Vacancies"
                            />{" "}
                          </div>
                          {!statePayload?.number_of_jobs &&
                            errors?.number_of_jobs && (
                              <p className="text-danger">
                                {" "}
                                {errors?.number_of_jobs}{" "}
                              </p>
                            )}
                        </Form.Group>
                      </Col>
                    )}
                    {selectedNumberOfJobsOption?.value === "Limited" && (
                      <Col lg={4}>
                        <Form.Group className="mb-4 floating-label">
                          <Form.Label className="float-label">
                            Number Of Openings
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Number Of Openings"
                            name="number_of_openings"
                            value={statePayload?.number_of_openings}
                            onChange={handleInput}
                            title="Please Enter Number Of Openings"
                          />
                          {errors?.number_of_openings && (
                            <p className="text-danger">
                              {" "}
                              {errors?.number_of_openings}{" "}
                            </p>
                          )}
                        </Form.Group>
                      </Col>
                    )}

                    {formFields?.jobMapping?.visible && (
                      <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                        <Form.Label className="float-label">
                          Job Mapping With
                        </Form.Label>
                        <div className="d-flex gap-4">
                          <Form.Check
                            type="radio"
                            id="option1"
                            name="location_mapped_with"
                            value="city"
                            label="City"
                            checked={["city"].includes(
                              statePayload?.location_mapped_with?.toLowerCase()
                            )}
                            onChange={e => {
                              setStatePayload(prev => ({
                                ...prev,
                                location_mapped_with: "city",
                              }));
                            }}
                            title="Please check Job mapping with"
                          />

                          <Form.Check
                            type="radio"
                            id="option2"
                            name="location_mapped_with"
                            value="franchise"
                            label="Franchise"
                            checked={["franchise"].includes(
                              statePayload?.location_mapped_with?.toLowerCase()
                            )}
                            onChange={e => {
                              setStatePayload(prev => ({
                                ...prev,
                                location_mapped_with: "franchise",
                              }));
                            }}
                            title="Please check Job mapping with"
                          />
                        </div>
                      </Form.Group>
                    )}
                    {["franchise"].includes(
                      statePayload?.location_mapped_with?.toLowerCase()
                    ) ? (
                      <>
                        {formFields?.city?.visible && (
                          <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                            <Form.Label className="float-label">
                              Dealership
                              <span className="text-danger">
                                {!isRemoteJOb && "*"}
                              </span>
                            </Form.Label>
                            <div
                              className="selectoption"
                              title={
                                FranchiseList?.find(
                                  f => f?.id === statePayload?.franchise_id
                                )?.label || "Please select Dealership"
                              }
                            >
                              <Select
                                options={FranchiseList}
                                value={FranchiseList?.find(
                                  f => f?.id === statePayload?.franchise_id
                                )}
                                onChange={e => {
                                  // console.log(userInfo?.locations,"userlocations")
                                  // console.log(e?.locationList,"locationslist")
                                  let locationList =
                                    e?.locationList?.filter(loc =>
                                      userInfo?.location_ids?.includes(loc.id)
                                    ) || [];
                                  // console.log(locationList,"locationList");
                                  setAllFranchiseLocations(locationList);
                                  setSelectedFranchiseLocations([]);

                                  setStatePayload(prev => ({
                                    ...prev,
                                    franchise_id: e?.value,
                                    franchise_location_id: [],
                                  }));
                                }}
                                placeholder={
                                  FranchiseList?.find(
                                    f => f?.id === statePayload?.franchise_id
                                  )?.label || "Dealership"
                                }
                                aria-label="Please select franchise"
                              />
                            </div>
                            {errors?.franchise_id && (
                              <p className="text-danger">
                                {" "}
                                {errors?.franchise_id}{" "}
                              </p>
                            )}
                          </Form.Group>
                        )}
                        {formFields?.jobLocation?.visible && (
                          <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                            <Form.Label
                              className="float-label"
                              id="job-location-label"
                            >
                              Job location (Min 1)
                              <span className="text-danger">
                                {!isRemoteJOb && "*"}
                              </span>
                            </Form.Label>
                            <div
                              className="selectoption"
                              title={
                                selectedFranchiseLocations.length > 0
                                  ? `${selectedFranchiseLocations.join(", ")}`
                                  : "Please select Job location "
                              }
                            >
                              <MultiSelect
                                options={extendedFranchiseLocationOptions}
                                value={selectedFranchiseLocations}
                                onChange={handleChangeFranchiseLocation}
                                placeholderText="Job location"
                                labelledBy="job-location-label" // Correctly references the Form.Label
                                placeholder="Job location"
                                overrideStrings={{
                                  selectSomeItems: "Job location",
                                }}
                                aria-describedby="job-location-label"
                              />
                            </div>
                            {errors?.selectedFranchiseLocations && (
                              <p className="text-danger">
                                {errors?.selectedFranchiseLocations}{" "}
                              </p>
                            )}
                          </Form.Group>
                        )}

                        {company.company_name == "Mahindra" && (
                          <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                            <div className="selectoption">
                              <Checkbox
                                style={{
                                  marginLeft: "-10px",
                                  marginTop: "-2px",
                                }}
                                checked={
                                  statePayload?.female_candidates_preferred
                                }
                                onChange={(checked, event) => {
                                  setStatePayload(prev => ({
                                    ...prev,
                                    female_candidates_preferred: event,
                                  }));
                                }}
                              />
                              <Form.Label
                                className="float-label"
                                id="job-location-label"
                              >
                                Preferred Female Candidates
                              </Form.Label>
                            </div>
                          </Form.Group>
                        )}
                      </>
                    ) : (
                      <>
                        {formFields?.city?.visible && (
                          <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                            <Form.Label className="float-label" id="city-label">
                              City{" "}
                              <span className="text-danger">
                                {!isRemoteJOb && "*"}
                              </span>
                            </Form.Label>
                            <div
                              className="selectoption"
                              title={
                                selectedCities.length
                                  ? selectedCities
                                    .map(city => city.label || city.name)
                                    .join(", ")
                                  : "Please select City"
                              }
                            >
                              <MultiSelect
                                options={extendedCityOptions}
                                value={selectedCities}
                                onChange={handleChangeCity}
                                placeholder="Select a city"
                                labelledBy="city-label"
                                overrideStrings={{
                                  selectSomeItems: "Select a city",
                                }}
                                aria-labelledby="city-label"
                                aria-describedby="city-description"
                              />
                            </div>
                            {selectedCities?.length == 0 && errors?.city_id && (
                              <p id="city-description" className="text-danger">
                                {errors?.city_id}
                              </p>
                            )}
                          </Form.Group>
                        )}

                        {formFields?.jobLocation?.visible && (
                          <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                            <Form.Label
                              className="float-label"
                              id="job-location-label"
                            >
                              Job location (Min 1){" "}
                              <span className="text-danger">
                                {!isRemoteJOb && "*"}
                              </span>
                            </Form.Label>
                            <div
                              className="selectoption"
                              title={
                                selectedCityLocations.length > 0
                                  ? `${selectedCityLocations
                                    .map(loc => loc.label)
                                    .join(", ")}`
                                  : "Please select Job location (Min 1)"
                              }
                            >
                              <MultiSelect
                                options={extendedCityLocationOptions}
                                value={selectedCityLocations}
                                onChange={handleChangeCityLocation}
                                formatGroupLabel={data => (
                                  <>
                                    <div className="d-flex align-items-center justify-content-between">
                                      <span>{data?.label}</span>
                                      <span className="border rounded-circle text-center p-2 pt-1 pb-1 bg-secondary text-light">
                                        {data?.options?.length || 0}
                                      </span>
                                    </div>
                                  </>
                                )}
                                labelledBy="job-location-label"
                                placeholderText="Job location"
                                placeholder="Job location"
                                overrideStrings={{
                                  selectSomeItems: "Job location",
                                }}
                                aria-labelledby="job-location-label"
                                aria-describedby="job-location-description"
                              />
                              <div
                                id="job-location-description"
                                className="sr-only"
                              >
                                Please select Job location (Minimum 1).
                              </div>
                            </div>
                            {errors?.selectedCityLocations &&
                              selectedCityLocations?.length === 0 && (
                                <p className="text-danger">
                                  {errors?.selectedCityLocations}{" "}
                                </p>
                              )}
                          </Form.Group>
                        )}
                      </>
                    )}
                    <Col lg={12} ref={dropdownRef}>
                      <Form.Group className="mb-4 floating-label">
                        <Form.Label className="float-label">
                          Educational Qualification{" "}
                          <span className="text-danger">*</span>
                        </Form.Label>
                        <p>
                          What level of education are you looking for (Select
                          max 3)
                        </p>
                        {formFields?.education?.visible && (
                          <div className="dropdown-flex align-items-start">
                            {selectedDegrees.length > 0 && (
                              <div className="selected-degrees">
                                <ul className="list-unstyled">
                                  {selectedDegrees.map((degree, index) => (
                                    <>
                                      <li
                                        key={index}
                                        className="btn btn-primary align-self-start"
                                      >
                                        <img
                                          src={check_icon}
                                          alt="Selected"
                                          className="plus-icon"
                                        />
                                        {degree}
                                        <button
                                          className="btn btn-danger btn-sm ms-2"
                                          onClick={e => {
                                            e.stopPropagation(); // Prevent triggering parent click
                                            handleDegreeRemove(degree);
                                          }}
                                        >
                                          <img src={white_cross} alt="" />
                                        </button>
                                      </li>
                                      <li>
                                        <Form.Group className="floating-label">
                                          {/* <Form.Label className="float-label">
                                            Specialization
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </Form.Label> */}
                                          <Form.Control
                                            type="text"
                                            placeholder="specialization"
                                            name="specialization"
                                            value={
                                              statePayload?.specializationMap?.[
                                              degree
                                              ]
                                            }
                                            onChange={e => {
                                              e.stopPropagation();
                                              handleSpecializationInput(
                                                degree,
                                                e.target.value
                                              );
                                            }}
                                            title="Specialization"
                                          />
                                          {!statePayload?.specializationMap?.[
                                            degree
                                          ] &&
                                            errors?.specializationMap?.[
                                            degree
                                            ] && (
                                              <p className="text-danger">
                                                {" "}
                                                {
                                                  errors?.specializationMap?.[
                                                  degree
                                                  ]
                                                }{" "}
                                              </p>
                                            )}
                                        </Form.Group>
                                      </li>
                                    </>
                                  ))}
                                </ul>
                              </div>
                            )}

                            <Dropdown>
                              <DropdownButton
                                title={
                                  <span>
                                    <img
                                      src={plus_icon}
                                      alt="Add"
                                      className="plus-icon"
                                    />
                                    Add Degree
                                  </span>
                                }
                                id="bg-nested-dropdown"
                                className="btn btn-primary border-s"
                                show={dropdownOpen}
                                onToggle={isOpen => setDropdownOpen(isOpen)}
                                disabled={selectedDegrees.length === 3}
                              >
                                {qualifications.map((degree, index) => (
                                  <Dropdown.Item
                                    key={index}
                                    onClick={() => handleDegreeSelect(degree)}
                                  >
                                    {degree}
                                  </Dropdown.Item>
                                ))}
                              </DropdownButton>
                            </Dropdown>
                          </div>
                        )}
                        {selectedDegrees?.length == 0 &&
                          errors?.qualification && (
                            <p className="text-danger">
                              {" "}
                              {errors?.qualification}{" "}
                            </p>
                          )}

                        {formFields?.specialization?.visible && (
                          <Col lg={4}>
                            <Form.Group className="mb-4 floating-label">
                              <Form.Label className="float-label">
                                Specialization
                                <span className="text-danger">*</span>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Write a clear Specialization for Education"
                                name="specialization"
                                value={statePayload?.specialization}
                                onChange={handleInput}
                                title="Write a clear Specialization for Education"
                              />
                              {!statePayload?.specialization &&
                                errors?.specialization && (
                                  <p className="text-danger">
                                    {" "}
                                    {errors?.specialization}
                                  </p>
                                )}
                            </Form.Group>
                          </Col>
                        )}
                      </Form.Group>
                    </Col>

                    <div className="seprator-border"></div>

                    {/* <Col lg={7}>
                        <Form.Group className="mb-4 floating-label">
                          <Form.Label className="float-label">
                            Required Experience
                          </Form.Label>

                          <div className="relevant-look">
                            <p>
                              What range of relevant experience are you looking
                              for?
                            </p>

                            <p>
                              <span>0</span> to <span>10</span> years
                            </p>
                          </div>
                          <RangeSlider
                            min={breakpoints[0]}
                            max={breakpoints[breakpoints.length - 1]}
                            value={[
                              statePayload?.min_exp,
                              statePayload?.max_exp,
                            ]}
                            onChange={e =>
                              handleSliderChange([
                                getNearestBreakpoint(e[0]),
                                getNearestBreakpoint(e[1]),
                              ])
                            }
                            tooltip="on"
                            className="dual-range mt-3"
                          />
                          <div className="d-flex justify-content-between mt-3">
                            {breakpoints.map((point, index) => (
                              <div key={index} className="mx-1">
                                {point}
                              </div>
                            ))}
                          </div>
                          {errors?.experience && (
                            <p className="text-danger">
                              {" "}
                              {errors?.experience}{" "}
                            </p>
                          )}
                        </Form.Group>
                      </Col> */}
                    {/* <Col lg={5}></Col> */}

                    <Col lg={7}>
                      <Form.Group className="mb-4 floating-label RequiredExperience">
                        <Form.Label className="float-label">
                          {t(`Edit Job.Required Experience`)}{" "}
                        </Form.Label>

                        <div className="relevant-look">
                          <p>{t(`Edit Job.Experience Text`)}</p>
                        </div>
                        <div className="reuwire-expirence">
                          {/* Min Experience Text Input */}
                          {formFields?.experienceMin?.visible && (
                            <div>
                              <Form.Control
                                type="number"
                                name="min_exp"
                                placeholder="Min Experience"
                                value={statePayload?.min_exp || ""}
                                onChange={handleMinExp}
                                min="0"
                                step="1"
                              />
                              {isEmpty(statePayload?.min_exp) &&
                                isEmpty(statePayload?.max_exp) &&
                                errors?.min_exp && (
                                  <p className="text-danger">
                                    {errors.min_exp}
                                  </p>
                                )}
                            </div>
                          )}

                          {/* Max Experience Text Input */}
                          {formFields?.experienceMax?.visible && (
                            <div>
                              <Form.Control
                                type="number"
                                name="max_exp"
                                placeholder="Max Experience"
                                value={statePayload?.max_exp || ""}
                                onChange={handleMaxExp}
                                min="0"
                                step="1"
                              />
                              {isEmpty(statePayload?.min_exp) &&
                                isEmpty(statePayload?.max_exp) &&
                                errors?.max_exp && (
                                  <p className="text-danger">
                                    {errors.max_exp}
                                  </p>
                                )}
                            </div>
                          )}
                          {/* Max Experience Text Input */}
                          {formFields?.relevantExperience?.visible && (
                            <div>
                              <Form.Control
                                type="number"
                                name="relevant_experience"
                                placeholder="Relevant Experience"
                                value={statePayload?.relevant_experience || ""}
                                onChange={handleRelevantExperience}
                                min="0"
                                step="1"
                              />
                              {errors?.relevant_experience && (
                                <p className="text-danger">
                                  {errors.relevant_experience}
                                </p>
                              )}
                            </div>
                          )}
                        </div>
                      </Form.Group>
                    </Col>

                    <div className="seprator-border"></div>

                    <Col lg={12}>
                      <Form.Group className="mb-4 floating-label">
                        <Form.Label className="float-label">
                          Must have skills
                        </Form.Label>
                        <p>
                          Add skills keywords to make your job more visible to
                          the right candidates.
                        </p>
                        <div className="dropdown-flex skill-cards">
                          {skills.length > 0 && (
                            <div className="selected-degrees">
                              <ul>
                                {skills.map((skill, index) => (
                                  <li key={index} className="btn btn-primary">
                                    <img
                                      src={check_icon}
                                      alt="Selected"
                                      className="plus-icon"
                                    />
                                    {skill.label}{" "}
                                    {/* Render the label instead of the whole object */}
                                    {skill.removable != false &&
                                      company.company_name == "Mahindra" && (
                                        <button
                                          className="btn btn-danger btn-sm ms-2"
                                          onClick={() =>
                                            setSkills(
                                              skills.filter(
                                                (s, i) => i !== index
                                              )
                                            )
                                          }
                                        >
                                          <img src={white_cross} alt="" />
                                        </button>
                                      )}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}

                          <div className="dropdown-flex addskill">
                            {formFields?.mustHaveSkills?.visible && (
                              <button
                                className="btn btn-primary border-s"
                                onClick={handleAddSkillClick}
                              >
                                <img
                                  src={plus_icon}
                                  alt="Add"
                                  className="plus-icon"
                                />
                                Add Skills
                              </button>
                            )}
                            {formFields?.aiSkillGen?.visible && (
                              <Button
                                className="btn btn-primary"
                                onClick={e => {
                                  e.preventDefault();
                                  handleContentGenerationOfSkill();
                                }}
                                disabled={contentLoading}
                              >
                                {" "}
                                {contentLoading ? (
                                  <Spinner className="mx-2" size="sm" />
                                ) : null}
                                <img src="../img/chatgpt.svg" alt="" />
                                Skill Generate by AI
                              </Button>
                            )}
                          </div>

                          {isOpen && (
                            <>
                              <div className="skill-card-dropdown">
                                <button
                                  className="close-btn"
                                  onClick={handleCloseClick}
                                  aria-label="Close"
                                >
                                  <img src={cross} alt="Close" />
                                </button>

                                <div className="keyskill-card">
                                  <h5>Key Skills</h5>
                                  <p>
                                    Add a skill that best defines your
                                    expertise.
                                  </p>
                                </div>

                                <div className="keyskill-card">
                                  <div className="keyskill-list">
                                    <ul>
                                      {skills.map((skill, index) => (
                                        <li
                                          key={index}
                                        // className="btn btn-primary"
                                        >
                                          {skill.label}
                                          {skill.removable != false &&
                                            company.company_name ==
                                            "Mahindra" && (
                                              <span
                                                // className="btn btn-danger btn-sm ms-2"
                                                onClick={() =>
                                                  setSkills(
                                                    skills.filter(
                                                      (s, i) => i !== index
                                                    )
                                                  )
                                                }
                                              >
                                                <img src={white_cross} alt="" />
                                              </span>
                                            )}
                                        </li> // Render the label here as well
                                      ))}
                                    </ul>
                                  </div>
                                </div>

                                <div className="keyskill-card">
                                  <Form.Group className="mt-4 floating-label">
                                    <Form.Control
                                      type="text"
                                      placeholder="Add Custom Skills"
                                      value={newSkill}
                                      onChange={e => {
                                        setNewSkill(e.target.value);
                                        handleSearchChange(e.target.value);
                                      }}
                                      onKeyDown={handleKeyDown}
                                      aria-label="Add a skill"
                                      title="Please enter the custom skill"
                                    />
                                    <button
                                      onClick={handleAddCustomSkill}
                                      className="btn btn-primary mt-2"
                                    >
                                      Add Custom Skills
                                    </button>
                                  </Form.Group>
                                </div>

                                <div className="keyskill-card suggestion">
                                  <p>
                                    Or you can select from the suggested skills:
                                  </p>
                                  <div className="keyskill-lists">
                                    <ul>
                                      {filteredSkills.map(skill => (
                                        <li
                                          key={skill.value}
                                          onClick={() => handleAddSkill(skill)}
                                          style={{ cursor: "pointer" }}
                                        >
                                          {skill.label}
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                </div>

                                <div className="save-btn pt-4 d-flex align-items-center gap-2 justify-content-end">
                                  <button
                                    className="btn btn-primary reset"
                                    onClick={handleCloseClick}
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    className="btn btn-primary"
                                    onClick={handleSaveSkills}
                                  >
                                    Save
                                  </button>
                                </div>
                              </div>

                              <div className="backshadow-card"></div>
                            </>
                          )}
                        </div>
                        {subdomain === "mahindra" && (
                          <div>
                            Note: These are the skills strongly recommended by
                            Mahindra.
                          </div>
                        )}

                        {skills?.length == 0 && errors?.skills && (
                          <p className="text-danger"> {errors?.skills} </p>
                        )}
                      </Form.Group>
                    </Col>

                    <Col lg={12}>
                      <Form.Group className="mb-4 mt-2 position-relative">
                        <Form.Label>Job Description</Form.Label>
                        {formFields?.jobDescription?.visible && (
                          <div title="Please enter  job description">
                            {formFields?.jobDescription?.editable ? (
                              <ReactQuill
                                placeholder="Enter job description here..."
                                name="description"
                                value={statePayload?.description}
                                onChange={content => {
                                  setStatePayload(prevState => ({
                                    ...prevState,
                                    ["description"]: content,
                                  }));
                                }}
                                readOnly={contentLoading}
                                title="Please enter  job description"
                                modules={modules}
                                formats={formats}
                              />
                            ) : (
                              <>
                                <button
                                  className="btn btn-primary border-s"
                                  onClick={() => setIsJobDescModalOpen(true)}
                                >
                                  View Job Description
                                </button>
                                {isJobDescModalOpen && (
                                  <>
                                    <div
                                      className="modal-organization"
                                      style={{
                                        maxWidth: "800px",
                                        maxHeight: "80vh",
                                        overflow: "auto",
                                      }}
                                    >
                                      <button
                                        className="btn btn-setopen1"
                                        style={{ zIndex: "1" }}
                                        onClick={() =>
                                          setIsJobDescModalOpen(false)
                                        }
                                      >
                                        <img src={cross} alt="Close" />
                                      </button>
                                      <div className="modal-contents">
                                        {statePayload?.description && (
                                          <JobDescription
                                            description={
                                              statePayload?.description
                                            }
                                            title="Job Description Preview"
                                          />
                                        )}
                                        {!statePayload?.description && (
                                          <p>No Job Description</p>
                                        )}
                                      </div>
                                    </div>
                                    <div
                                      className="backshadow-card"
                                      onClick={() =>
                                        setIsJobDescModalOpen(false)
                                      }
                                    ></div>
                                  </>
                                )}
                              </>
                            )}
                          </div>
                        )}
                        {formFields?.jobDescription?.editable && (
                          <div className="fileposp">
                            <div className="file-upload">
                              <Form.Control
                                type="file"
                                accept=".pdf,.docx"
                                onChange={handleFileChange}
                                style={{ display: "none" }} // Hide the default input for better UX
                              />
                              {/* <div
                                onClick={() =>
                                  document
                                    .querySelector('input[type="file"]')
                                    .click()
                                }
                                className="upload-jd"
                              >
                                Upload JD
                                <div class="info-icon">
                                  <span>
                                    <img src={info_icon} alt="" />
                                  </span>
                                  <p>
                                    you can upload a Job Description (JD) in PDF
                                    or Word format.
                                  </p>
                                </div>
                              </div> */}
                              {/* {uploadedFile && (
                                <div className="mt-2">
                                  <strong>Uploaded File:</strong>{" "}
                                  {uploadedFile.name}
                                </div>
                              )} */}
                            </div>
                            {formFields?.aiDescriptionGen?.visible && (
                              <div className="job-desc-btn">
                                <Button
                                  color="success"
                                  className="px-2 py-1"
                                  onClick={e => {
                                    e.preventDefault();
                                    handleContentGeneration();
                                  }}
                                  disabled={contentLoading}
                                >
                                  {" "}
                                  {contentLoading ? (
                                    <Spinner className="mx-2" size="sm" />
                                  ) : null}
                                  <img src="../img/chatgpt.svg" alt="" />
                                  AI Generate
                                </Button>

                                <div className="job-chat-dec">
                                  <p>
                                    AI Generated Content <br />
                                    <small>*Powered by Bard AI</small>
                                  </p>
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                        {errors?.description && (
                          <p className="text-danger mt-5">
                            {" "}
                            {errors?.description}{" "}
                          </p>
                        )}
                      </Form.Group>
                    </Col>
                  </>
                )}

                {/* Step 2: Account Information */}
                {currentStep === 2 && (
                  <>
                    <div className="heading-interview">
                      <div>
                        <h2>
                          Step 2: What are the interview stages for your job?
                        </h2>
                        <p>
                          Note: Please be aware that this field cannot be
                          modified later.
                        </p>
                      </div>
                    </div>

                    {isHumanCloudProcessAppl() && (
                      <Col lg={12}>
                        <Row>
                          <Col lg={6} md={12}>
                            <Form.Group className="floating-label mb-2">
                              <Form.Label className="float-label font-size-18">
                                Select a round template from the list
                              </Form.Label>

                              <Select
                                options={roundTemplates}
                                value={selectedRoundTemplate}
                                onChange={e => {
                                  setSelectedRoundTemplate(e);

                                  let rounds = e?.InterviewTitles?.sort(
                                    (r1, r2) =>
                                      r1?.round_template_interview
                                        ?.round_order -
                                      r2?.round_template_interview?.round_order
                                  )?.map(t => t?.id);

                                  let filtered = rounds?.map(r =>
                                    allRoundList?.find(
                                      t => parseInt(t?.value) === parseInt(r)
                                    )
                                  );
                                  let filteredOut = allRoundList?.filter(
                                    r => !rounds?.includes(parseInt(r?.value))
                                  );
                                  setRoundList(filteredOut);
                                  setSelectedRounds(filtered);
                                }}
                                placeholder="Select Round Template"
                                aria-label="Select Round Template"
                              />
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row>
                          <Col lg={6} md={12} className="text-center">
                            <Form.Group className="floating-label">
                              <Form.Label className="float-label font-size-18">
                                OR
                              </Form.Label>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Col>
                    )}

                    <Col lg={6} md="12">
                      <Form.Group className="mb-4 floating-label round">
                        <Form.Label className="float-label">
                          Available Rounds
                          <span className="text-danger">*</span>
                        </Form.Label>
                        <div className="round-card">
                          {roundList.length > 0 ? (
                            roundList?.map(item => (
                              <div
                                key={item?.label}
                                className="available-round"
                                onClick={() => handleAddRound(item)}
                              >
                                <h4>
                                  {" "}
                                  {item?.label} [{item?.type}]
                                </h4>
                                <span>
                                  <img src={arrow_btn} alt="arrow_btn" />
                                </span>
                              </div>
                            ))
                          ) : (
                            <div className="availble-info-round">
                              <img src={available_round} alt="round" />
                              <h5>No Rounds Selected</h5>
                              <p>
                                Drag an available round and drop it under the
                                Selected Round
                              </p>
                            </div>
                          )}
                        </div>
                        {selectedRounds?.length == 0 && errors?.roundList && (
                          <p className="text-danger"> {errors?.roundList} </p>
                        )}
                      </Form.Group>
                    </Col>

                    <Col lg={6} md="12">
                      <Form.Group className="mb-4 floating-label round">
                        <Form.Label className="float-label">
                          Selected Rounds
                          <span className="text-danger">*</span>
                        </Form.Label>
                        <div className="round-card  d-none">
                          {selectedRounds?.map((item, index) => (
                            <>
                              <div
                                key={item?.label}
                                className="selected-round available-round w-100"
                              >
                                <div className="d-flex align-items-center gap-3  four-rounds-ca">
                                  <span>
                                    <img src={four_dost} alt="" />
                                  </span>

                                  <div className="green-card-round">
                                    <h5>{`${index + 1}`}</h5>
                                  </div>

                                  <h4>{` ${item?.label} [${item?.type}]`}</h4>

                                  {/* {item?.alias === "pre-assessment" && ( */}
                                  <>
                                    <div
                                      className="faexample-icon"
                                      style={{
                                        marginLeft: "5px",
                                        position: "relative",
                                        zindex: "10",
                                      }}
                                    >
                                      <FontAwesomeIcon
                                        icon={faExclamation}
                                        id="my-tooltip-1"
                                      />
                                      <Tooltip
                                        anchorSelect="#my-tooltip-1"
                                        place="bottom"
                                        content="This Round will not be considered as a Main Round."
                                      />
                                    </div>
                                  </>
                                  {/* )} */}
                                </div>

                                <div
                                  className="delete-cod"
                                  onClick={() => handleRemoveRound(item)}
                                >
                                  <img src={delete_icon} alt="" />
                                </div>
                              </div>

                              <div className="interview-card">
                                {item?.type === "Interview" && (
                                  <>
                                    <div
                                      className="select-drop"
                                      title="Please select  interviewer"
                                    >
                                      {/* <MultiSelect
                                          options={interviewerList || []}
                                          value={
                                            interviewerList?.find(
                                              val =>
                                                val?.value ===
                                                item?.interviewer_id
                                            ) || []
                                          }
                                          onChange={e => {
                                            handleSelectInterviewer(e, index);
                                          }}
                                          placeholder="Select Interviewer"
                                          placeholderText="Select Interviewer"
                                          aria-label="Select Interviewer" // Use aria-label for accessibility
                                          overrideStrings={{
                                            selectSomeItems:
                                              "Select Interviewer",
                                          }}
                                        /> */}
                                      <Select
                                        options={interviewerList}
                                        value={interviewerList?.find(
                                          val =>
                                            val?.value === item?.interviewer_id
                                        )}
                                        isMulti
                                        onChange={e => {
                                          handleSelectInterviewer(e, index);
                                        }}
                                        placeholder="Select Interviewer"
                                        aria-label="Select Interviewer"
                                      />
                                    </div>
                                    <div
                                      className="select-drop"
                                      title="Please enter type"
                                    >
                                      <Select
                                        options={interviewTypes}
                                        value={interviewTypes?.find(
                                          val =>
                                            val?.value === item?.meeting_type
                                        )}
                                        onChange={e => {
                                          handleSelectInterviewType(e, index);
                                        }}
                                        isMulti
                                        placeholder="Select Type"
                                        title="Please select  Type"
                                        aria-label="Please select  Type"
                                      />
                                    </div>
                                  </>
                                )}
                                {item?.type === "Test" && (
                                  <>
                                    <div className="select-drop">
                                      <Form.Control
                                        type="text"
                                        placeholder="Enter Passing Threshold"
                                        name="min_salary"
                                        value={item?.score_threshold}
                                        onChange={e => {
                                          handleScoreThreshold(
                                            e.target.value,
                                            index
                                          );
                                        }}
                                        title="Please enter passing threshold"
                                      />
                                    </div>
                                  </>
                                )}
                                {/* <div className="d-flex gap-3  select-drop deleteico">
                                        <FontAwesomeIcon
                                          className="text-danger"
                                          icon={faTrash}
                                          onClick={() =>
                                            handleRemoveRound(item)
                                          }
                                          role="button"
                                          title="Remove Round"
                                        />
                                      </div> */}
                              </div>
                            </>
                          ))}
                        </div>

                        <div className="round-card">
                          <ReactSortable
                            list={selectedRounds}
                            setList={setSelectedRounds}
                            className="special-rounds-sa w-100"
                          >
                            {selectedRounds?.map((item, index) => (
                              <div className="special-card-imdex">
                                <div
                                  className="selected-round available-round w-100"
                                  key={item?.label}
                                >
                                  <div className="d-flex align-items-center gap-3  four-rounds-ca">
                                    <span>
                                      <img src={four_dost} alt="" />
                                    </span>

                                    <div className="green-card-round">
                                      <h5>{`${index + 1}`}</h5>
                                    </div>

                                    <h4>{` ${item?.label} [${item?.type}]`}</h4>

                                    {/* {item?.alias === "pre-assessment" && (
                                        <>
                                          <div className="faexample-icon">
                                            <FontAwesomeIcon
                                              icon={faExclamation}
                                              id="my-tooltip-1"
                                            />
                                            <Tooltip
                                              anchorSelect="#my-tooltip-1"
                                              place="bottom"
                                              content="This Round will not be considered as a Main Round."
                                            />
                                          </div>
                                        </>
                                      )} */}
                                    <div className="faexample-icon">
                                      <FontAwesomeIcon
                                        icon={faExclamation}
                                        id={`my-tooltip-${index + 1}`}
                                      />
                                      <Tooltip
                                        anchorSelect={`#my-tooltip-${index + 1
                                          }`}
                                        place="right"
                                        content={item.description}
                                        className="tooltip-max-width"
                                      />
                                    </div>
                                  </div>
                                  <div
                                    className="delete-cod"
                                    onClick={() => handleRemoveRound(item)}
                                  >
                                    <img src={delete_icon} alt="" />
                                  </div>
                                </div>

                                <div className="interview-card">
                                  {item?.type === "Interview" && (
                                    <>
                                      <div
                                        className="select-drop"
                                        title={
                                          interviewerList?.find(
                                            val =>
                                              val?.value ===
                                              item?.interviewer_id
                                          )?.label || "Please enter interviewer"
                                        }
                                      >
                                        <Select
                                          options={interviewerList}
                                          value={interviewerList?.find(
                                            val =>
                                              val?.value ===
                                              item?.interviewer_id
                                          )}
                                          onChange={e => {
                                            handleSelectInterviewer(e, index);
                                          }}
                                          isMulti
                                          placeholder="Select Interviewer"
                                          aria-label="Please enter interviewer"
                                        />
                                      </div>
                                      <div
                                        className="select-drop"
                                        title={
                                          interviewTypes?.find(
                                            val =>
                                              val?.value === item?.meeting_type
                                          )?.label || "Please enter type"
                                        }
                                      >
                                        <Select
                                          options={interviewTypes}
                                          value={interviewTypes?.find(
                                            val =>
                                              val?.value === item?.meeting_type
                                          )}
                                          onChange={e => {
                                            handleSelectInterviewType(e, index);
                                          }}
                                          placeholder="Select Type"
                                          aria-label="Please enter type"
                                        />
                                      </div>
                                    </>
                                  )}
                                  {item?.type === "Test" && (
                                    <>
                                      <div className="select-drop">
                                        <Form.Control
                                          type="text"
                                          placeholder="Enter Passing Threshold"
                                          name="min_salary"
                                          value={item?.score_threshold}
                                          onChange={e => {
                                            handleScoreThreshold(
                                              e.target.value,
                                              index
                                            );
                                          }}
                                          title="Please enter passing threshold"
                                        />
                                      </div>
                                    </>
                                  )}
                                  {/* <div className="d-flex gap-3  select-drop deleteico">
                                        <FontAwesomeIcon
                                          className="text-danger"
                                          icon={faTrash}
                                          onClick={() =>
                                            handleRemoveRound(item)
                                          }
                                          role="button"
                                          title="Remove Round"
                                        />
                                      </div> */}
                                </div>
                              </div>
                            ))}
                          </ReactSortable>
                        </div>
                        {selectedRounds?.length === 0 ? (
                          <div className="availble-info-round">
                            <img src={available_round} alt="round" />
                            <h5>No Rounds Selected</h5>
                            <p>
                              Drag an available round and drop it under the
                              Selected Round
                            </p>
                          </div>
                        ) : (
                          <p className="notes">
                            Note: You can drag and drop the rounds to alter the
                            order.
                          </p>
                        )}
                      </Form.Group>
                    </Col>
                  </>
                )}

                {/* Step 3: Address Information */}
                {currentStep === 3 && (
                  <>
                    <div className="heading-interview">
                      <h2>
                        {company?.company_name == "Mahindra"
                          ? `Step 3: Establish Annual CTC Range`
                          : `Step 3: Establish Budget Range and Minimum Criteria for
                        Relevancy, Behavior, and Video Questions`}
                      </h2>
                    </div>
                    {company?.company_name != "Mahindra" && (
                      <div className="row">
                        <Col lg={4}>
                          <Form.Group className=" mb-4 floating-label">
                            <Form.Label className="float-label">
                              Required Expected Time
                              <span class="text-danger">*</span>
                            </Form.Label>

                            <div
                              title={
                                expectedTimeOptions?.find(
                                  el => el.value === statePayload?.expected_time
                                )?.label || "Required Expected Time"
                              }
                            >
                              <Select
                                options={expectedTimeOptions}
                                value={
                                  expectedTimeOptions?.find(
                                    el =>
                                      el?.value === statePayload?.expected_time
                                  ) || ""
                                }
                                onChange={e => {
                                  setStatePayload(prevState => ({
                                    ...prevState,
                                    expected_time: e?.value,
                                  }));
                                }}
                                placeholder="Required Expected Time"
                                aria-label="Please select Expected Time"
                              />
                            </div>
                            {!statePayload?.expected_time &&
                              errors?.expected_time && (
                                <p className="text-danger">
                                  {" "}
                                  {errors?.expected_time}{" "}
                                </p>
                              )}
                          </Form.Group>
                        </Col>
                        {/* <Col lg={7}>
                        <Form.Group className="mb-4 pb-3 floating-label">
                          <Form.Label className="float-label d-flex gap-4 pb-2">
                            Budget Range
                            <span className="range-crad">
                              A$ {statePayload?.min_salary} - A${" "}
                              {statePayload?.max_salary}
                            </span>
                          </Form.Label>
                          <RangeSlider
                            min={0}
                            max={100000}
                            value={[
                              statePayload?.min_salary,
                              statePayload?.max_salary,
                            ]}
                            onChange={handleSliderChange2}
                            tooltip="on"
                            className="dual-range mt-3"
                          />
                          <div className="d-flex justify-content-between mt-3">
                            <div className="mx-1">A$0</div>
                            <div className="mx-1">A$100,000</div>
                          </div>
                        </Form.Group>
                      </Col> */}

                        {/* <Col lg={5}></Col> */}

                        {statePayload?.expected_time ===
                          t(`job-list.expectedTimeOptions_child1.value`) && (
                            // Part-Time selected → Show Hourly/Daily dropdown
                            <Col lg={4}>
                              <Form.Group className="mb-4 floating-label">
                                <Form.Label className="float-label">
                                  Part-Time Type{" "}
                                  <span className="text-danger">*</span>
                                </Form.Label>
                                <Select
                                  options={[
                                    { label: "Select PartTime Type", value: "" },
                                    { label: "Hourly", value: "hourly" },
                                    { label: "Daily", value: "daily" },
                                  ]}
                                  value={
                                    partTimeType
                                      ? {
                                        label: partTimeType,
                                        value: partTimeType,
                                      }
                                      : null
                                  }
                                  onChange={e => setPartTimeType(e?.value)}
                                  placeholder="Select Part-Time Type"
                                  aria-label="Please select Hourly or Daily"
                                />
                                {!partTimeType && (
                                  <p className="text-danger">
                                    Part-Time type is required
                                  </p>
                                )}
                              </Form.Group>
                            </Col>
                          )}
                      </div>
                    )}

                    <Col lg={8}>
                      <Form.Group className="mb-4 floating-label">
                        <Form.Label className="float-label d-flex gap-4">
                          {statePayload?.expected_time ===
                            t(`job-list.expectedTimeOptions_child2.value`)
                            ? company?.company_name == "Mahindra"
                              ? "Annual CTC"
                              : "Budget Range(CTC)"
                            : `Budget Range ${partTimeType ? `(${partTimeType})` : ""
                            }`}

                          <span className="range-crad">
                            ₹ {statePayload?.min_salary} - ₹{" "}
                            {statePayload?.max_salary}
                          </span>
                        </Form.Label>
                        <Row>
                          <Col>
                            <div className="reuwire-expirence">
                              <Form.Control
                                type="text"
                                placeholder="Minimum Budget"
                                name="min_salary"
                                value={statePayload?.min_salary}
                                onChange={(e) => {
                                  const value = e.target.value.replace(/\D/g, '');

                                  setStatePayload({
                                    ...statePayload,
                                    min_salary: value
                                  });
                                }}
                                title="Please enter minimum budget"
                              />
                            </div>
                          </Col>
                          <Col>
                            <div className="reuwire-expirence">
                              <Form.Control
  type="text"
  placeholder="Maximum Budget"
  name="max_salary"
  value={statePayload?.max_salary}
  onChange={(e) => {
    const value = e.target.value.replace(/\D/g, '');

    setStatePayload({
      ...statePayload,
      max_salary: value
    });
  }}
  title="Please enter maximum budget"
/>
                            </div>
                          </Col>
                        </Row>
                      </Form.Group>
                      {errors?.min_salary && (
                        <p className="text-danger"> {errors?.min_salary} </p>
                      )}
                    </Col>

                    {company?.company_name != "Mahindra" && (
                      <>
                        <Col lg={3}>
                          <Form.Group className="mb-3 floating-label">
                            <Form.Label className="float-label">
                              {t(`all-application.Start Date`)}
                            </Form.Label>
                            <DatePicker
                              placeholder={t(`all-application.Start Date`)}
                              className="form-control"
                              type={"date"}
                              onChange={e => {
                                setStartDate(e);
                              }}
                              placeholderText={t(`all-application.Start Date`)}
                              id="date"
                              selected={startDate}
                            />
                          </Form.Group>
                        </Col>
                        <Col lg={4} xl={3} md={6}>
                          <Form.Group
                            className="mb-4 floating-label"
                            style={{ position: "relative", zIndex: "10" }}
                          >
                            <Form.Label className="float-label d-flex align-items-center">
                              Min Relevancy Score %
                              <span class="text-danger">*</span>
                              <div
                                className="faexample-icon"
                                style={{ marginLeft: "5px" }}
                              >
                                <FontAwesomeIcon
                                  icon={faExclamation}
                                  id="my-tooltip-1"
                                />
                                <Tooltip
                                  anchorSelect="#my-tooltip-1"
                                  place="bottom"
                                  content="Sets the minimum match score between JD and resume. Candidates below this score will be auto-rejected. Set to 0 to disable auto-rejection. Rejection email is sent after 24 hours. ."
                                />
                              </div>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Min Relevancy Score %"
                              name="relevance_score"
                              value={statePayload?.relevance_score}
                              onChange={handleInput}
                              title="Please enter min relevancy score %"
                            />
                            {!statePayload?.relevance_score &&
                              errors?.relevance_score && (
                                <p className="text-danger">
                                  {" "}
                                  {errors?.relevance_score}{" "}
                                </p>
                              )}
                          </Form.Group>
                        </Col>
                        <Col lg={4} xl={3} md={6}>
                          <Form.Group className="mb-4 floating-label">
                            <Form.Label className="float-label">
                              Min Behavioural Score %
                              {isBehaviourScoreEnabled && (
                                <span class="text-danger">*</span>
                              )}
                            </Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Min Behavioural Score %"
                              name="video_analysis_score"
                              value={statePayload?.video_analysis_score}
                              onChange={handleInput}
                              title="Please enter min behavioural score %"
                            />
                            {!statePayload?.video_analysis_score &&
                              errors?.video_analysis_score && (
                                <p className="text-danger  mb-0 pb-1">
                                  {" "}
                                  {errors?.video_analysis_score}{" "}
                                </p>
                              )}
                          </Form.Group>
                        </Col>

                        <Col
                          lg={4}
                          xl={5}
                          md={3}
                          className="d-flex align-items-center jobstatues"
                        >
                          <Form.Group className="col-xl-6 col-lg-12 mb-4 floating-label status-swith-table ">
                            <Form.Label className="float-label">
                              Job Status
                              <span class="text-danger">*</span>
                            </Form.Label>
                            <div
                              className="action-application"
                              title={
                                statusUpdateOptions.find(
                                  option =>
                                    option.value === currentStatus
                                )?.label || "Please enter job status"
                              }
                            >
                              <Select
                                className="w-100"
                                placeholder="Draft"
                                options={statusUpdateOptions.map(option => ({
                                  ...option,
                                  // Disable the selected option by checking if the current value matches the option's value
                                  disabled:
                                    option.value === currentStatus ||
                                    option.disabled,
                                }))}
                                // Set the current status as the selected value
                                value={statusUpdateOptions.find(
                                  option =>
                                    option.value === currentStatus
                                )}
                                onChange={e => {
                                  handleStatusChange(e);
                                }}
                                isOptionDisabled={option => option.disabled}
                                // menuIsOpen={true}
                                aria-label="Please enter job status"
                              />
                            </div>
                            {/* <div className=" d-flex gap-3">
                            <Form.Label className="float-label pb-0 mb-0">
                              Status<span className="text-danger">*</span>
                            </Form.Label>
                            <label
                              className="switch pb-0 mb-0"
                              htmlFor={"tableSwitch"}
                            >
                              <input
                                type="checkbox"
                                id={`tableSwitch`}
                                onChange={e => {
                                  let value = e.target.checked ? "1" : "0";
                                  handleInput({
                                    target: { name: "status", value: value },
                                  });
                                }}
                                checked={statePayload?.status === "1"}
                              />
                              <div className="slider round"></div>
                            </label>
                            {errors?.status && (
                              <p className="text-danger"> {errors?.status} </p>
                            )}
                          </div> */}

                            {/* <div className="d-flex gap-3">
                            <Form.Label className="float-label pb-0 mb-0">
                              License Applicable
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <label
                              className="switch pb-0 mb-0"
                              htmlFor={"licenseSwitch"}
                            >
                              <input
                                type="checkbox"
                                id={`licenseSwitch`}
                                onChange={e => {
                                  let value = e.target.checked ? "1" : "0";
                                  handleInput({
                                    target: {
                                      name: "licenseApplicable",
                                      value: value,
                                    },
                                  });
                                }}
                                checked={
                                  statePayload?.licenseApplicable === "1"
                                }
                              />
                              <div className="slider round"></div>
                            </label>
                            {errors?.license && (
                              <p className="text-danger"> {errors?.license} </p>
                            )}
                          </div> */}
                            {!jobStatus && errors?.jobStatus && (
                              <p className="text-danger  mb-0 pb-1">
                                {" "}
                                {errors?.jobStatus}{" "}
                              </p>
                            )}
                          </Form.Group>
                        </Col>

                        <Col lg={12}>
                          <Form.Group className="mb-4 mt-3 position-relative">
                            <Form.Label>
                              Video Analysis Question{" "}
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <div title="Please enter video analysis question">
                              <ReactQuill
                                className="comment-card"
                                style={{ height: "150px" }}
                                name="video_analysis_ques"
                                placeholder="Video Analysis Questions"
                                value={statePayload?.video_analysis_ques}
                                onChange={content => {
                                  setStatePayload(prevState => ({
                                    ...prevState,
                                    ["video_analysis_ques"]: content,
                                  }));
                                }}
                              />
                            </div>
                            {isEmpty(statePayload?.video_analysis_ques) &&
                              errors?.video_analysis_ques && (
                                <p className="text-danger mt-5  mb-0 pb-1">
                                  {" "}
                                  {errors?.video_analysis_ques}{" "}
                                </p>
                              )}
                          </Form.Group>
                        </Col>
                      </>
                    )}

                    {isSocialEnable && (
                      <JobPublishForm
                        checkedPlatforms={checkedPlatforms}
                        setCheckedPlatforms={setCheckedPlatforms}
                      />
                    )}
                  </>
                )}

                {isHumanCloudProcessAppl() && currentStep === 4 && (
                  <>
                    <div className="heading-interview">
                      <h2>
                        Step 4: Additional Details for Human Cloud Process
                      </h2>
                    </div>

                    <Col md={6} sm={12}>
                      <Form.Group className="mb-4 floating-label">
                        <Form.Label className="float-label">
                          Collaboration Tools<span class="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          rows="4"
                          as="textarea"
                          placeholder="e.g., Zoom, Slack, Teams, etc."
                          name="collaboration_tool"
                          value={humanCloudProcessAMValues?.collaboration_tool}
                          onChange={e => {
                            let key = "collaboration_tool";

                            handleChangeAMValues(key, e?.target?.value);

                            setAMValueErrors(prev => ({
                              ...(prev || {}),
                              [key]: !!e?.target?.value
                                ? null
                                : "Collaboration Tools is required",
                            }));
                          }}
                          title="Collaboration Tools"
                        />
                        {!humanCloudProcessAMValues?.collaboration_tool &&
                          amValueErrors?.collaboration_tool && (
                            <p className="text-danger">
                              {" "}
                              {amValueErrors?.collaboration_tool}{" "}
                            </p>
                          )}
                      </Form.Group>
                    </Col>

                    <Col md={6} sm={12}>
                      <Form.Group className="mb-4 floating-label">
                        <Form.Label className="float-label">
                          Programming Languages
                          <span class="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          rows="4"
                          as="textarea"
                          placeholder="e.g., Java, C++, Python, etc."
                          name="programming_languages"
                          value={
                            humanCloudProcessAMValues?.programming_languages
                          }
                          onChange={e => {
                            let key = "programming_languages";

                            handleChangeAMValues(key, e?.target?.value);

                            setAMValueErrors(prev => ({
                              ...(prev || {}),
                              [key]: !!e?.target?.value
                                ? null
                                : "Programming Languages is required",
                            }));
                          }}
                          title="Programming Languages"
                        />
                        {!humanCloudProcessAMValues?.programming_languages &&
                          amValueErrors?.programming_languages && (
                            <p className="text-danger">
                              {" "}
                              {amValueErrors?.programming_languages}{" "}
                            </p>
                          )}
                      </Form.Group>
                    </Col>

                    <Col md={6} sm={12}>
                      <Form.Group className="mb-4 floating-label">
                        <Form.Label className="float-label">
                          IDE Preferences
                          <span class="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          rows="4"
                          as="textarea"
                          placeholder="e.g., Visual Studio, VS Code, Notepad++, etc."
                          name="ide_preferences"
                          value={humanCloudProcessAMValues?.ide_preferences}
                          onChange={e => {
                            let key = "ide_preferences";

                            handleChangeAMValues(key, e?.target?.value);

                            setAMValueErrors(prev => ({
                              ...(prev || {}),
                              [key]: !!e?.target?.value
                                ? null
                                : "IDE Preferences is required",
                            }));
                          }}
                          title="IDE Preferences"
                        />
                        {!humanCloudProcessAMValues?.ide_preferences &&
                          amValueErrors?.ide_preferences && (
                            <p className="text-danger">
                              {" "}
                              {amValueErrors?.ide_preferences}{" "}
                            </p>
                          )}
                      </Form.Group>
                    </Col>

                    <Col md={6} sm={12}>
                      <Form.Group className="mb-4 floating-label">
                        <Form.Label className="float-label">
                          Version Control Systems
                          <span class="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          rows="4"
                          as="textarea"
                          placeholder="e.g., Git, BitBucket, etc."
                          name="version_control_systems"
                          value={
                            humanCloudProcessAMValues?.version_control_systems
                          }
                          onChange={e => {
                            let key = "version_control_systems";

                            handleChangeAMValues(key, e?.target?.value);

                            setAMValueErrors(prev => ({
                              ...(prev || {}),
                              [key]: !!e?.target?.value
                                ? null
                                : "Version Control Systems is required",
                            }));
                          }}
                          title="Version Control Systems"
                        />
                        {!humanCloudProcessAMValues?.version_control_systems &&
                          amValueErrors?.version_control_systems && (
                            <p className="text-danger">
                              {" "}
                              {amValueErrors?.version_control_systems}{" "}
                            </p>
                          )}
                      </Form.Group>
                    </Col>

                    <Col md={6} sm={12}>
                      <Form.Group className="mb-4 floating-label">
                        <Form.Label className="float-label">
                          Timesheet Process
                          <span class="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="e.g., Hourly, Weekly, Milestone Based"
                          name="timesheet_process"
                          value={humanCloudProcessAMValues?.timesheet_process}
                          onChange={e => {
                            let key = "timesheet_process";

                            handleChangeAMValues(key, e?.target?.value);

                            setAMValueErrors(prev => ({
                              ...(prev || {}),
                              [key]: !!e?.target?.value
                                ? null
                                : "Timesheet Process is required",
                            }));
                          }}
                          title="Timesheet Process"
                        />
                        {!humanCloudProcessAMValues?.timesheet_process &&
                          amValueErrors?.timesheet_process && (
                            <p className="text-danger">
                              {" "}
                              {amValueErrors?.timesheet_process}{" "}
                            </p>
                          )}
                      </Form.Group>
                    </Col>

                    <Col md={6} sm={12}>
                      <Form.Group className="mb-4 floating-label">
                        <Form.Label className="float-label">
                          Billing Process
                          <span class="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="e.g., Hourly, Weekly, Milestone Based, Payment Terms"
                          name="billing_process"
                          value={humanCloudProcessAMValues?.billing_process}
                          onChange={e => {
                            let key = "billing_process";

                            handleChangeAMValues(key, e?.target?.value);

                            setAMValueErrors(prev => ({
                              ...(prev || {}),
                              [key]: !!e?.target?.value
                                ? null
                                : "Billing Process is required",
                            }));
                          }}
                          title="Billing Process"
                        />
                        {!humanCloudProcessAMValues?.billing_process &&
                          amValueErrors?.billing_process && (
                            <p className="text-danger">
                              {" "}
                              {amValueErrors?.billing_process}{" "}
                            </p>
                          )}
                      </Form.Group>
                    </Col>

                    <Col md={4} sm={6} xs={12}>
                      <Form.Group className="mb-4 floating-label d-flex align-items-center">
                        <Form.Label className="float-label me-2 mb-0">
                          Timesheet Approval by Client
                        </Form.Label>
                        <Form.Check
                          type="checkbox"
                          name="timesheet_approval"
                          checked={
                            humanCloudProcessAMValues?.timesheet_approval
                          }
                          onChange={e => {
                            let key = "timesheet_approval";

                            handleChangeAMValues(key, e?.target?.checked);
                          }}
                          title="Timesheet Approval by Client"
                        />
                      </Form.Group>
                    </Col>

                    <Col md={4} sm={6} xs={12}>
                      <Form.Group className="mb-4 floating-label d-flex align-items-center">
                        <Form.Label className="float-label me-2 mb-0">
                          Billing Approval by Client
                        </Form.Label>
                        <Form.Check
                          type="checkbox"
                          name="billing_approval"
                          checked={humanCloudProcessAMValues?.billing_approval}
                          onChange={e => {
                            let key = "billing_approval";

                            handleChangeAMValues(key, e?.target?.checked);
                          }}
                          title="Billing Approval by Client"
                        />
                      </Form.Group>
                    </Col>

                    <Col md={4} sm={6} xs={12}>
                      <Form.Group className="mb-4 floating-label d-flex align-items-center">
                        <Form.Label className="float-label me-2 mb-0">
                          Completed Work Approval by Client
                        </Form.Label>
                        <Form.Check
                          type="checkbox"
                          name="completed_work_approval"
                          checked={
                            humanCloudProcessAMValues?.completed_work_approval
                          }
                          onChange={e => {
                            let key = "completed_work_approval";

                            handleChangeAMValues(key, e?.target?.checked);
                          }}
                          title="Completed Work Approval by Client"
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6} sm={12}>
                      <Form.Group className="mb-4 floating-label">
                        <Form.Label>
                          Contracting & Compliance Documents
                          <span className="text-danger">*</span>
                        </Form.Label>
                        <label className="btn btn-sm btn-primary ms-2">
                          Upload File(s)
                          <Form.Control
                            className="d-none"
                            type="file"
                            multiple
                            accept=".pdf,.docx,.doc"
                            onChange={e => {
                              let key = "contract_compliance_documents";

                              handleAMFilesUpload(e, key);
                            }}
                          />
                        </label>
                      </Form.Group>
                      {uploadedFiles.contract_compliance_documents?.length >
                        0 && (
                          <ul className="mt-3">
                            {uploadedFiles.contract_compliance_documents.map(
                              (file, index) => (
                                <li
                                  key={index}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <a
                                    href={URL.createObjectURL(file)}
                                    download={file.name}
                                    style={{
                                      marginLeft: "10px",
                                      color: "#007bff",
                                      textDecoration: "underline",
                                    }}
                                  >
                                    <svg
                                      className="w-6 h-6 text-gray-800 dark:text-white"
                                      aria-hidden="true"
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                    >
                                      <path
                                        stroke="currentColor"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M12 13V4M7 14H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-2m-1-5-4 5-4-5m9 8h.01"
                                      />
                                    </svg>

                                    {file.name}
                                  </a>
                                </li>
                              )
                            )}
                          </ul>
                        )}
                    </Col>

                    <Col md={6} sm={12}>
                      <Form.Group className="mb-4 floating-label">
                        <Form.Label>
                          NDA & IP Protection Agreements
                          <span className="text-danger">*</span>
                        </Form.Label>
                        <label className="btn btn-sm btn-primary ms-2">
                          Upload File(s)
                          <Form.Control
                            className="d-none"
                            type="file"
                            multiple
                            accept=".pdf,.docx,.doc"
                            onChange={e => {
                              let key = "nda_ip_protection_agreements";

                              handleAMFilesUpload(e, key);
                            }}
                          />
                        </label>
                      </Form.Group>
                      {uploadedFiles.nda_ip_protection_agreements?.length >
                        0 && (
                          <ul
                            className="mt-3"
                            style={{ listStyle: "none", paddingLeft: 0 }}
                          >
                            {uploadedFiles.nda_ip_protection_agreements.map(
                              (file, index) => (
                                <li key={index}>
                                  <a
                                    href={URL.createObjectURL(file)}
                                    download={file.name}
                                    style={{
                                      textDecoration: "underline",
                                      color: "#007bff",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <svg
                                      class="w-6 h-6 text-gray-800 dark:text-white"
                                      aria-hidden="true"
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                    >
                                      <path
                                        stroke="currentColor"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M12 13V4M7 14H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-2m-1-5-4 5-4-5m9 8h.01"
                                      />
                                    </svg>
                                    {file.name}
                                  </a>
                                </li>
                              )
                            )}
                          </ul>
                        )}
                    </Col>
                  </>
                )}

                <div className="navigation-buttons creatjob d-flex gap-3">
                  {currentStep > 1 && (
                    <button
                      type="button"
                      onClick={prevStep}
                      className="btn btn-primary border-s"
                    >
                      Back
                    </button>
                  )}
                  {/* Show the Next button for steps 1 and 2 */}

                  {currentStep === 1 && (
                    <Link to="/job-list">
                      <button
                        type="button"
                        className="btn btn-primary border-s"
                      >
                        Cancel
                      </button>
                    </Link>
                  )}

                  {((isHumanCloudProcessAppl() && currentStep === 4) ||
                    (!isHumanCloudProcessAppl() && currentStep === 3)) && (
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={e => {
                          if (company?.company_name == "Mahindra") {
                            if (
                              window.confirm(
                                `Do you confirm that the annual CTC you entered (₹ ${statePayload?.min_salary} - ₹ ${statePayload?.max_salary}) is according to the minimum wage?`
                              )
                            ) {
                              handleSubmit(e);
                            }
                          } else {
                            handleSubmit(e);
                          }
                        }}
                      >
                        Submit
                      </button>
                    )}

                  {((isHumanCloudProcessAppl() && currentStep < 4) ||
                    (!isHumanCloudProcessAppl() && currentStep < 3)) && (
                      <button
                        type="button"
                        onClick={handleSaveAndContinue}
                        className="btn btn-primary"
                      >
                        Save & Continue
                      </button>
                    )}
                </div>
              </Row>
            ) : (
              // Preview form data after submission
              <div className="form-preview">
                <div className="form-card-preview">
                  <Row>
                    <div className="heading-interview ">
                      <h2>Step 1: What job do you want to post?</h2>
                    </div>

                    <Col lg={4} md="6">
                      <Form.Group className="mb-4 floating-label">
                        <Form.Label className="float-label">
                          Job Title/Designation
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Write a clear title for more targeted and helpful replies"
                          name="title"
                          title="Write a clear title for more targeted and helpful replies"
                        />
                      </Form.Group>
                    </Col>

                    <Col lg={4} md="6">
                      <Form.Group className=" mb-4 floating-label">
                        <Form.Label className="float-label">
                          Position Level
                        </Form.Label>
                        <Select
                          value={selectedOption}
                          onChange={handleSingleSelectChange}
                          options={options}
                          placeholder="Select Position Level"
                          aria-label="Position Level"
                        />
                      </Form.Group>
                    </Col>

                    <Col lg={4} md="6">
                      <Form.Group className="mb-4 floating-label">
                        <Form.Label className="float-label">
                          Mode of Job
                        </Form.Label>
                        <div title={selectedModeOfJob?.label || "Mode of Job"}>
                          <Select
                            value={selectedOption}
                            onChange={handleSingleSelectChange}
                            options={options}
                            placeholder="Select where the candidate will be working from"
                            aria-label="Mode of Job"
                          />
                        </div>
                      </Form.Group>
                    </Col>

                    <Col lg={4} md="6">
                      <Form.Group className="mb-4 floating-label">
                        <Form.Label className="float-label">
                          Number of Vacancies
                        </Form.Label>
                        <Select
                          value={selectedOption}
                          onChange={handleSingleSelectChange}
                          options={options}
                          placeholder="Select Number"
                          aria-label="Number of Vacancies"
                          disabled={
                            localStorage.getItem("subdomain") === "mahindra"
                          }
                        />
                      </Form.Group>
                    </Col>

                    <Col lg={4} md="6">
                      <Form.Group className="mb-4 floating-label">
                        <Form.Label className="float-label">City</Form.Label>
                        <Select
                          value={selectedOption}
                          onChange={handleSingleSelectChange}
                          options={options}
                          placeholder="Select City"
                          aria-label="Select City"
                        />
                      </Form.Group>
                    </Col>

                    <Col lg={4} md="6">
                      <Form.Group className="mb-4 floating-label">
                        <Form.Label className="float-label">
                          Job location (Maximum 3)
                        </Form.Label>
                        <Select
                          value={selectedOption}
                          onChange={handleSingleSelectChange}
                          options={options}
                          placeholder="Search and add locations"
                          aria-label="Job location (Maximum 3)"
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={4} md="6">
                      <Form.Group className=" mb-4 floating-label">
                        <Form.Label className="float-label">
                          Department
                        </Form.Label>
                        <Select
                          value={selectedOption}
                          onChange={handleSingleSelectChange}
                          options={options}
                          placeholder="Select Department"
                          aria-label="Select Department"
                        />
                      </Form.Group>
                    </Col>

                    <Col lg={4} md="6">
                      <Form.Group className=" mb-4 floating-label">
                        <Form.Label className="float-label">
                          Required Expected Time
                        </Form.Label>
                        <Select
                          value={selectedOption}
                          onChange={handleSingleSelectChange}
                          options={options}
                          placeholder="Select Time"
                          aria-label="Required Expected Time"
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={4}></Col>
                    <Col lg={4} md="6">
                      <Form.Group className=" mb-4 floating-label">
                        <Form.Label className="float-label">
                          Educational Qualification
                        </Form.Label>
                        <MultiSelect
                          value={selectedOption}
                          onChange={handleSingleSelectChange}
                          options={options}
                          placeholder="Select Department"
                          // isMulti
                          aria-label="Educational Qualification"
                        />
                      </Form.Group>
                    </Col>

                    <Col lg={4} md="6">
                      <Form.Group className=" mb-4 floating-label RequiredExperience">
                        <Form.Label className="float-label">
                          Required Experience
                        </Form.Label>
                        <Select
                          value={selectedOption}
                          onChange={handleSingleSelectChange}
                          options={options}
                          placeholder="Select Time"
                          aria-label="Required Experience"
                        />
                      </Form.Group>
                    </Col>

                    <Col lg={4} md="6">
                      <Form.Group className=" mb-4 floating-label">
                        <Form.Label className="float-label">Skills</Form.Label>
                        <MultiSelect
                          value={selectedOption}
                          onChange={handleSingleSelectChange}
                          options={options}
                          placeholder="Select Department"
                          // isMulti
                          aria-label="select Skills"
                        />
                      </Form.Group>
                    </Col>

                    <Col lg={12}>
                      <Form.Group className="mb-4 mt-2 position-relative">
                        {/* Job Description Label */}
                        <Form.Label htmlFor="job-description-editor">
                          Job Description
                        </Form.Label>
                        <ReactQuill
                          id="job-description-editor"
                          value={jobDescription}
                          onChange={handleJobDescriptionChange}
                          placeholder="Enter job description here..."
                        />

                        {/* Hidden File Input with Label */}
                        <div className="file-upload">
                          <Form.Label
                            htmlFor="file-upload"
                            className="upload-jd"
                          >
                            Upload JD
                            <div className="info-icon">
                              <span>
                                <img src={info_icon} alt="Info" />
                              </span>
                              <p>
                                You can upload a Job Description (JD) in PDF or
                                Word format.
                              </p>
                            </div>
                          </Form.Label>
                          <Form.Control
                            id="file-upload"
                            type="file"
                            accept=".pdf,.docx"
                            onChange={handleFileChange}
                            style={{ display: "none" }} // Hide the default input for better UX
                          />
                        </div>

                        {/* AI Generate Button */}
                        <div className="job-desc-btn">
                          <Button color="success" className="px-2 py-1">
                            <img src="../img/chatgpt.svg" alt="AI Generate" />
                            AI Generate
                          </Button>
                          <div className="job-chat-dec">
                            <p>
                              AI Generated Content <br />
                              <small>*Powered by Bard AI</small>
                            </p>
                          </div>
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                </div>

                <div className="form-card-preview">
                  <Row>
                    <div className="heading-interview">
                      <div>
                        <h2>
                          Step 2: What are the interview stages for your job?
                        </h2>
                      </div>
                    </div>
                    <Col lg={12}>
                      <Form.Group className="mb-2 floating-label round preivie">
                        <div className="round-card">
                          <div class="available-round">
                            <h4>Logical Test [Test]</h4>
                          </div>
                          <div class="available-round">
                            <h4>HR Round [Interview]</h4>
                          </div>
                          <div class="available-round">
                            <h4>Technical Round [Interview]</h4>
                          </div>
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                </div>

                <div className="form-card-preview">
                  <Row>
                    <div className="heading-interview">
                      <h2>
                        Step 3: Establish Budget Range and Minimum Criteria for
                        Relevancy, Behavior, and Video Questions
                      </h2>
                    </div>

                    <Col lg={3} md="6">
                      <Form.Group className="mb-4 floating-label">
                        <Form.Label className="float-label">
                          Minimum Budget Range
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Min Relevancy Score %"
                          name="title"
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={3} md="6">
                      <Form.Group className="mb-4 floating-label">
                        <Form.Label className="float-label">
                          Maximum Budget Range
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Min Relevancy Score %"
                          name="title"
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={3}></Col>
                    <Col lg={3}></Col>

                    <Col lg={3} md="6">
                      <Form.Group className="mb-4 floating-label">
                        <Form.Label className="float-label">
                          Min Relevancy Score %
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Min Relevancy Score %"
                          name="title"
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={3} md="6">
                      <Form.Group className="mb-4 floating-label">
                        <Form.Label className="float-label">
                          Min Behavioural Score %
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Min Behavioural Score %"
                          name="title"
                        />
                      </Form.Group>
                    </Col>

                    <Col lg={6} className="d-flex align-items-center">
                      <Form.Group className="col-md-2 mb-4 floating-label status-swith-table d-flex align-items-center w-100 gap-4">
                        <div className=" d-flex gap-3">
                          <Form.Label className="float-label pb-0 mb-0">
                            Status
                          </Form.Label>
                          <label
                            className="switch pb-0 mb-0"
                            htmlFor={"tableSwitch"}
                          >
                            <input
                              type="checkbox"
                              id={`tableSwitch`}
                              onChange={e => {
                                let value = e.target.checked ? "1" : "0";
                                handleInput({
                                  target: { name: "status", value: value },
                                });
                              }}
                              checked={statePayload?.status === "1"}
                            />
                            <div className="slider round"></div>
                          </label>
                        </div>

                        <div className="d-flex gap-3">
                          <Form.Label className="float-label pb-0 mb-0">
                            License Applicable
                          </Form.Label>
                          <label
                            className="switch pb-0 mb-0"
                            htmlFor={"licenseSwitch"}
                          >
                            <input
                              type="checkbox"
                              id={`licenseSwitch`}
                              onChange={e => {
                                let value = e.target.checked ? "1" : "0";
                                handleInput({
                                  target: {
                                    name: "licenseApplicable",
                                    value: value,
                                  },
                                });
                              }}
                              checked={statePayload?.licenseApplicable === "1"}
                            />
                            <div className="slider round"></div>
                          </label>
                        </div>
                      </Form.Group>
                    </Col>

                    <Col lg={12}>
                      <Form.Group className="mb-4 mt-3 position-relative">
                        <Form.Label>Video Analysis Question</Form.Label>
                        <ReactQuill
                          value={jobDescription}
                          onChange={handleJobDescriptionChange}
                          placeholder="Enter job description here..."
                        />
                      </Form.Group>
                    </Col>

                    <Col lg={12}>
                      <Form.Group className="mb-4 mt-3 position-relative">
                        <Form.Label>
                          Do you want to publish this job across other platforms
                          too?
                        </Form.Label>
                        <div className="job-across-list">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              value=""
                              id="flexCheckDefault"
                            />
                            <label
                              class="form-check-label"
                              for="flexCheckDefault"
                            >
                              All
                            </label>
                          </div>
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              value=""
                              id="flexCheckDefault"
                            />
                            <label
                              class="form-check-label"
                              for="flexCheckDefault"
                            >
                              <img src={naukricom} alt="naukri" />
                            </label>
                          </div>

                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              value=""
                              id="flexCheckDefault"
                            />
                            <label
                              class="form-check-label"
                              for="flexCheckDefault"
                            >
                              <img src={linkedins} alt="linkedins" />
                            </label>
                          </div>

                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              value=""
                              id="flexCheckDefault"
                            />
                            <label
                              class="form-check-label"
                              for="flexCheckDefault"
                            >
                              <img src={indeed} alt="indeed" />
                            </label>
                          </div>

                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              value=""
                              id="flexCheckDefault"
                            />
                            <label
                              class="form-check-label"
                              for="flexCheckDefault"
                            >
                              <img src={monster} alt="monster" />
                            </label>
                          </div>
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                </div>

                <div className="navigation-buttons d-flex gap-3">
                  {/* Show the Previous button for steps 2 and 3 */}

                  <button type="button" className="btn btn-primary border-s">
                    Cancel
                  </button>

                  <button type="button" className="btn btn-primary">
                    Update Details
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default CreateJobNew;
